var _defs, _defs2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs3, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.6007,
    y1: -43.9194,
    x2: 255.1426,
    y2: 303.0009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7EFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M379.982,403.477c-15.569,15.628-33.325,26.46-52.867,29.393 c-3.756,0.564-7.664,0.835-11.731,0.835c-27.183,0-60.82-12.143-94.744-30.228C138.919,359.914,55.571,281.862,56.988,256.03 C59.063,218.209,162.47,56.162,223.672,56.162c0.541,0,1.087,0.012,1.628,0.041c87.021,4.185,196.206,89.66,219.669,137.232 C463.301,230.598,435.595,347.654,379.982,403.477z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141414363813058962550000010357513400653829306_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.5928,
    y1: 226.838,
    x2: 251.6157,
    y2: 330.467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141414363813058962550000010357513400653829306_)"
    },
    d: "M272.683,233.573 c-5.77-2.647-0.439,14.801,4.042,18.068C276.725,251.641,278.453,236.22,272.683,233.573z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036938653756934218000000015999534675762423967_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.0995,
    y1: 227.717,
    x2: 255.1223,
    y2: 331.346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036938653756934218000000015999534675762423967_)"
    },
    d: "M294.845,247.837 c-4.192-3.63-14.882,1.981-17.522,3.461l-0.009-0.005c-0.003,0.005-0.006,0.01-0.009,0.015 c-0.373,0.209-0.58,0.333-0.58,0.333c0.093,0.053,0.193,0.102,0.295,0.151c-2.043,3.416-3.891,6.858-5.565,10.304 c0.256-3.085,0.906-15.035-4.111-17.336c-5.683-2.607-0.598,14.268,3.838,17.9c-2.201,4.582-4.098,9.166-5.723,13.699 c-0.59-2.627-3.618-14.793-9.238-15.476c-6.204-0.754,3.763,13.762,9.095,15.882c-2.189,6.16-3.889,12.22-5.198,18.039 c-1.017-2.958-5.217-14.111-10.723-14.202c-6.206-0.103,5.019,13.111,10.586,14.815c-1.275,5.773-2.168,11.299-2.783,16.448 c-1.012-2.662-5.676-14.07-11.284-13.962c-6.248,0.12,5.647,13.098,11.224,14.454c-0.492,4.215-0.799,8.171-0.974,11.787 c-0.126,2.599-0.189,5.099-0.206,7.484c-1.36-2.571-7.36-13.24-12.891-12.451c-6.18,0.882,7.179,12.287,12.89,12.972 c-0.061,15.987,2.021,26.674,2.046,26.797l0.576-0.115c-0.024-0.122-2.096-10.757-2.034-26.683 c5.717-0.698,19.055-12.089,12.878-12.97c-5.51-0.786-11.487,9.802-12.877,12.424c0.017-2.368,0.08-4.85,0.205-7.429 c0.175-3.604,0.481-7.547,0.971-11.748c5.772-0.013,20.366-9.671,14.35-11.299c-5.355-1.449-12.55,8.258-14.282,10.732 c0.613-5.112,1.501-10.597,2.766-16.325c5.679,0.325,20.859-8.918,14.864-10.773c-5.428-1.68-13.2,8.262-14.774,10.371 c1.313-5.873,3.027-11.994,5.24-18.216c5.72,0.79,21.513-6.73,15.785-9.183c-5.039-2.157-13.375,6.215-15.56,8.544 c1.588-4.401,3.436-8.849,5.569-13.295c5.224,2.483,22.532,0.121,17.825-3.954c-4.244-3.674-15.143,2.119-17.611,3.511 c1.703-3.517,3.586-7.031,5.673-10.516C283.35,254.118,299.399,251.78,294.845,247.837z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040550332486136104700000016174678968626045350_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.0909,
    y1: 309.9954,
    x2: 253.2529,
    y2: 394.6305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040550332486136104700000016174678968626045350_)"
    },
    points: "272.259,403.475  235.109,403.475 229.802,351.102 277.566,351.102  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090278081821205485000000006018078594959731902_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.1669,
    y1: 103.4873,
    x2: 379.0885,
    y2: 297.0587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090278081821205485000000006018078594959731902_)"
    },
    d: "M364.703,355.539 c0,0-10.271-45.916-1.826-80.325c8.446-34.409-9.648-29.018-1.439-52.453c8.209-23.435-11.339-15.574-2.193-39.197 c9.145-23.623-9.528-23.375-2.496-41.725c6.613,13.912,23.498,23.187,19.245,39.289c-4.252,16.102,16.182,27.051,7.222,45.25 c-8.96,18.198,24.559,54.449,15.76,89.325S368.62,381.154,364.703,355.539z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097462605206874709570000006342396393428499076_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.6101,
    y1: 192.0057,
    x2: 385.0356,
    y2: 350.3822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097462605206874709570000006342396393428499076_)"
    },
    d: "M349.637,393.824 c0,0,57.3-94.693,53.11-137.682c-4.19-42.989,31.424-44.22,33.1-5.057c1.676,39.162-55.032,152.288-80.308,160.249 C330.263,419.294,349.637,393.824,349.637,393.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M417.412,222.761 c0,0,18.102,66.375-69.928,190.112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M402.956,261.816 c0,0,11.185,6.451,11.354,14.926c10.434-10.588,21.116-16.877,21.116-16.877"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M397.256,292.454 c0,0,7.86,8.598,7.619,15.764c0,0,12.372-11.268,20.835-11.373"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M384.929,325.345 c0,0,6.719,7.844,5.879,15.701c11.52-5.131,18.101-4.461,18.101-4.461"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M373.292,350.305 c0,0,5.169,6.208,4.114,16.021c9.63-5.9,17.906-3.744,17.906-3.744"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: "M362.299,371.475 c0,0,3.116,8.634,2.404,15.867c9.344-3.452,15.93-1.23,15.93-1.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174588237291917329730000003797965559385208738_",
    gradientUnits: "userSpaceOnUse",
    x1: 547.6434,
    y1: 280.6056,
    x2: 516.9932,
    y2: 392.007,
    gradientTransform: "matrix(-0.8453 -0.5344 -0.5344 0.8453 1009.1478 292.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174588237291917329730000003797965559385208738_)"
    },
    d: "M367.362,386.806 c0,0,1.525-77.842,20.176-101.827c18.651-23.985-2.062-38.104-17.779-15.449c-15.717,22.655-24.524,111.234-12.487,125.468 C369.308,409.233,367.362,386.806,367.362,386.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M391.367,259.619 c0,0-35.713,32.66-29.884,139.322"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M385.281,288.274 c0,0-9.075-0.369-12.362,4.607c-2.224-10.217-6.211-17.972-6.211-17.972"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M377.154,308.634 c0,0-7.905,2.158-10.456,6.509c0,0-3.121-11.351-8.113-14.594"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M372.119,332.824 c0,0-6.944,2.138-9.398,7.126c-4.921-7.381-9.086-9.456-9.086-9.456"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M369.657,352.039 c0,0-5.407,1.749-8.468,7.979c-3.508-7.128-9.239-8.957-9.239-8.957"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4134,
      strokeMiterlimit: 10
    },
    d: "M368.235,368.758 c0,0-5.099,3.962-7.394,8.53c-4.258-5.565-9.009-6.719-9.009-6.719"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027602311477597038440000015051168789286718619_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.3983,
    y1: 345.8377,
    x2: 299.513,
    y2: 445.7657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027602311477597038440000015051168789286718619_)"
    },
    d: "M379.982,403.477 c-15.569,15.628-33.325,26.46-52.867,29.393c-3.756,0.564-7.664,0.835-11.731,0.835c-27.183,0-60.82-12.143-94.744-30.228 H379.982z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139270959983597889530000017344070750918109584_",
    d: "M379.982,403.477 c-15.569,15.628-33.325,26.46-52.867,29.393c-3.756,0.564-7.664,0.835-11.731,0.835c-27.183,0-60.82-12.143-94.744-30.228 C138.919,359.914,55.571,281.862,56.988,256.03C59.063,218.209,162.47,56.162,223.672,56.162c0.541,0,1.087,0.012,1.628,0.041 c87.021,4.185,196.206,89.66,219.669,137.232C463.301,230.598,435.595,347.654,379.982,403.477z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000154416639521030945480000002270041072034834596_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139270959983597889530000017344070750918109584_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154416639521030945480000002270041072034834596_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098211079807759706350000001611618790795650179_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.404,
    y1: 32.0762,
    x2: 251.823,
    y2: 138.4962,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098211079807759706350000001611618790795650179_)"
    },
    d: "M223.33,63.805 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C222.369,62.377,223.182,62.95,223.33,63.805z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114772676466291652330000009523783222825681078_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.1969,
    y1: 32.0319,
    x2: 263.6159,
    y2: 138.4485,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114772676466291652330000009523783222825681078_)"
    },
    d: "M234.951,61.795 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C233.99,60.368,234.803,60.941,234.951,61.795z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165955677695966853020000010105853257096840350_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.9897,
    y1: 31.9836,
    x2: 275.4088,
    y2: 138.4036,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165955677695966853020000010105853257096840350_)"
    },
    d: "M246.571,59.786 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C245.611,58.358,246.424,58.931,246.571,59.786z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036239269077667173820000007425015369718584206_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.7826,
    y1: 31.9376,
    x2: 287.2016,
    y2: 138.3576,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036239269077667173820000007425015369718584206_)"
    },
    d: "M258.192,57.777 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C257.232,56.349,258.045,56.922,258.192,57.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170248054302481004030000009651330489514816140_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.5755,
    y1: 31.8914,
    x2: 298.9945,
    y2: 138.3113,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170248054302481004030000009651330489514816140_)"
    },
    d: "M269.813,55.767 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C268.853,54.34,269.665,54.913,269.813,55.767z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100346400645874171220000000864473528347026870_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.3683,
    y1: 31.845,
    x2: 310.7874,
    y2: 138.265,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100346400645874171220000000864473528347026870_)"
    },
    d: "M281.434,53.758 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C280.474,52.33,281.286,52.903,281.434,53.758z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170965885224860240570000004660515875443262358_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.3668,
    y1: 32.0763,
    x2: 251.7858,
    y2: 138.4962,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170965885224860240570000004660515875443262358_)"
    },
    d: "M224.935,73.089 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C223.975,71.661,224.787,72.234,224.935,73.089z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131350671137037076100000000721760069634203792_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.1596,
    y1: 32.0303,
    x2: 263.5787,
    y2: 138.4502,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131350671137037076100000000721760069634203792_)"
    },
    d: "M236.556,71.079 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C235.596,69.652,236.408,70.225,236.556,71.079z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089574663854901491660000015177451316922486680_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.9525,
    y1: 31.984,
    x2: 275.3715,
    y2: 138.404,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089574663854901491660000015177451316922486680_)"
    },
    d: "M248.177,69.07 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C247.216,67.643,248.029,68.215,248.177,69.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160911996475540777010000013757802268798974130_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.7454,
    y1: 31.9377,
    x2: 287.1644,
    y2: 138.3576,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160911996475540777010000013757802268798974130_)"
    },
    d: "M259.798,67.061 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C258.837,65.633,259.65,66.206,259.798,67.061z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083786495776643699140000015403744540533270947_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.5382,
    y1: 31.8914,
    x2: 298.9572,
    y2: 138.3114,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083786495776643699140000015403744540533270947_)"
    },
    d: "M271.419,65.051 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C270.458,63.624,271.271,64.197,271.419,65.051z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181780012600960447100000012682890559472331937_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.3311,
    y1: 31.8451,
    x2: 310.7501,
    y2: 138.265,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181780012600960447100000012682890559472331937_)"
    },
    d: "M283.039,63.042 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C282.079,61.614,282.892,62.187,283.039,63.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150077802308234217290000002727109438952167103_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.3295,
    y1: 32.0767,
    x2: 251.7486,
    y2: 138.4966,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150077802308234217290000002727109438952167103_)"
    },
    d: "M226.54,82.373 c0.148,0.854-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C225.58,80.945,226.393,81.518,226.54,82.373z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183970626358403723880000012827977555941842063_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.1224,
    y1: 32.0303,
    x2: 263.5414,
    y2: 138.4503,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183970626358403723880000012827977555941842063_)"
    },
    d: "M238.161,80.364 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C237.201,78.936,238.013,79.509,238.161,80.364z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084515518003776448650000014657161291471927463_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.9153,
    y1: 31.9841,
    x2: 275.3343,
    y2: 138.4041,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084515518003776448650000014657161291471927463_)"
    },
    d: "M249.782,78.354 c0.148,0.854-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C248.822,76.927,249.634,77.5,249.782,78.354z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003820060912198776400000003463552184146366082_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.7081,
    y1: 31.9378,
    x2: 287.1271,
    y2: 138.3577,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003820060912198776400000003463552184146366082_)"
    },
    d: "M261.403,76.345 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C260.443,74.917,261.255,75.49,261.403,76.345z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033358704565565824580000000409582132408322480_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.501,
    y1: 31.8914,
    x2: 298.92,
    y2: 138.3114,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033358704565565824580000000409582132408322480_)"
    },
    d: "M273.024,74.335 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C272.064,72.908,272.876,73.481,273.024,74.335z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111174467357413588170000010845977955232802453_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2939,
    y1: 31.8451,
    x2: 310.7129,
    y2: 138.2651,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111174467357413588170000010845977955232802453_)"
    },
    d: "M284.645,72.326 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C283.684,70.898,284.497,71.471,284.645,72.326z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069399694003827151330000007654381444201034405_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2923,
    y1: 32.0795,
    x2: 251.7113,
    y2: 138.4962,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069399694003827151330000007654381444201034405_)"
    },
    d: "M228.146,91.657 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C227.185,90.229,227.998,90.802,228.146,91.657z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058585209069487224550000008747369760520834456_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.0851,
    y1: 32.0304,
    x2: 263.5042,
    y2: 138.4504,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058585209069487224550000008747369760520834456_)"
    },
    d: "M239.766,89.648 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C238.806,88.22,239.619,88.793,239.766,89.648z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141434570769545398940000011446365603247140536_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.878,
    y1: 31.9841,
    x2: 275.297,
    y2: 138.404,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141434570769545398940000011446365603247140536_)"
    },
    d: "M251.387,87.638 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C250.427,86.211,251.24,86.784,251.387,87.638z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137106536646270696230000003776841155858862770_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.6709,
    y1: 31.9378,
    x2: 287.0899,
    y2: 138.3578,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137106536646270696230000003776841155858862770_)"
    },
    d: "M263.008,85.629 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C262.048,84.201,262.861,84.774,263.008,85.629z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177443552366281962930000003543879695596741052_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.4637,
    y1: 31.8915,
    x2: 298.8828,
    y2: 138.3114,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177443552366281962930000003543879695596741052_)"
    },
    d: "M274.629,83.619 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C273.669,82.192,274.481,82.765,274.629,83.619z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182492401873545466130000001052136511256652441_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2566,
    y1: 31.8455,
    x2: 310.6756,
    y2: 138.2655,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182492401873545466130000001052136511256652441_)"
    },
    d: "M286.25,81.61 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C285.29,80.183,286.102,80.756,286.25,81.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003788542056939924180000004437482524735585436_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2551,
    y1: 32.0767,
    x2: 251.6741,
    y2: 138.4967,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003788542056939924180000004437482524735585436_)"
    },
    d: "M229.751,100.941 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C228.791,99.513,229.603,100.087,229.751,100.941z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008114579709216100180000009319519078590919567_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.0479,
    y1: 32.0304,
    x2: 263.4669,
    y2: 138.4504,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008114579709216100180000009319519078590919567_)"
    },
    d: "M241.372,98.932 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C240.411,97.504,241.224,98.077,241.372,98.932z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114757549308841021500000008899993416540022919_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.8408,
    y1: 31.9841,
    x2: 275.2598,
    y2: 138.4041,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114757549308841021500000008899993416540022919_)"
    },
    d: "M252.993,96.922 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C252.032,95.495,252.845,96.068,252.993,96.922z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176746190160554882000000016337807218749146512_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.6336,
    y1: 31.9382,
    x2: 287.0526,
    y2: 138.3582,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176746190160554882000000016337807218749146512_)"
    },
    d: "M264.614,94.913 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C263.653,93.485,264.466,94.058,264.614,94.913z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000187536660475621660000005568772185885183136_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.4265,
    y1: 31.8919,
    x2: 298.8455,
    y2: 138.3118,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000187536660475621660000005568772185885183136_)"
    },
    d: "M276.234,92.904 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C275.274,91.476,276.087,92.049,276.234,92.904z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079474690004938204890000001511801994382854327_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2194,
    y1: 31.8456,
    x2: 310.6384,
    y2: 138.2656,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079474690004938204890000001511801994382854327_)"
    },
    d: "M287.855,90.894 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C286.895,89.467,287.708,90.04,287.855,90.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173120557366313163130000013075878507086957478_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2178,
    y1: 32.0768,
    x2: 251.6369,
    y2: 138.4967,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173120557366313163130000013075878507086957478_)"
    },
    d: "M231.356,110.225 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C230.396,108.798,231.208,109.37,231.356,110.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010989939802544525370000000142836803044939948_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.0107,
    y1: 32.0305,
    x2: 263.4297,
    y2: 138.4505,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010989939802544525370000000142836803044939948_)"
    },
    d: "M242.977,108.216 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C242.017,106.788,242.829,107.361,242.977,108.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140008111851032470440000015861365681600181388_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.8035,
    y1: 31.9845,
    x2: 275.2226,
    y2: 138.4045,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140008111851032470440000015861365681600181388_)"
    },
    d: "M254.598,106.206 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C253.638,104.779,254.45,105.352,254.598,106.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102531827001859088920000016618246642543700616_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5964,
    y1: 31.9417,
    x2: 287.0154,
    y2: 138.3583,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102531827001859088920000016618246642543700616_)"
    },
    d: "M266.219,104.197 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C265.259,102.77,266.071,103.342,266.219,104.197z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047062437267140349810000015153865445128029058_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.3893,
    y1: 31.8919,
    x2: 298.8083,
    y2: 138.3119,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047062437267140349810000015153865445128029058_)"
    },
    d: "M277.84,102.188 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C276.879,100.76,277.692,101.333,277.84,102.188z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018920989621439790740000014018468074055708560_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.1821,
    y1: 31.8456,
    x2: 310.6012,
    y2: 138.2655,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018920989621439790740000014018468074055708560_)"
    },
    d: "M289.461,100.178 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C288.5,98.751,289.313,99.324,289.461,100.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181808687510572727880000008541110060623942813_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.1806,
    y1: 32.0772,
    x2: 251.5996,
    y2: 138.4971,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181808687510572727880000008541110060623942813_)"
    },
    d: "M232.961,119.509 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C232.001,118.082,232.814,118.655,232.961,119.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026149511301168010930000009211678962108765880_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.9734,
    y1: 32.0308,
    x2: 263.3925,
    y2: 138.4508,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026149511301168010930000009211678962108765880_)"
    },
    d: "M244.582,117.5 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C243.622,116.072,244.435,116.645,244.582,117.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063607098098162036460000005893191009038812058_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.7663,
    y1: 31.9846,
    x2: 275.1853,
    y2: 138.4046,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063607098098162036460000005893191009038812058_)"
    },
    d: "M256.203,115.491 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C255.243,114.063,256.056,114.636,256.203,115.491z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158021622938666966980000005104350623699499918_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.5591,
    y1: 31.9382,
    x2: 286.9782,
    y2: 138.3582,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158021622938666966980000005104350623699499918_)"
    },
    d: "M267.824,113.481 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C266.864,112.054,267.676,112.627,267.824,113.481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013905242173542865260000017137367876736745120_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.352,
    y1: 31.892,
    x2: 298.771,
    y2: 138.312,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013905242173542865260000017137367876736745120_)"
    },
    d: "M279.445,111.472 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C278.485,110.044,279.297,110.617,279.445,111.472z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041286526131605728990000015675326014325191332_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.1449,
    y1: 31.8457,
    x2: 310.5639,
    y2: 138.2656,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041286526131605728990000015675326014325191332_)"
    },
    d: "M291.066,109.462 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28s0.425-1.667,1.28-1.815 C290.106,108.035,290.918,108.608,291.066,109.462z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154416639521030945480000002270041072034834596_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101096498810767820070000004427683047926957215_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.3654,
    y1: 437.6878,
    x2: 150.6701,
    y2: 322.0509,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101096498810767820070000004427683047926957215_)"
    },
    d: "M153.615,336.922 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C152.655,335.494,153.467,336.067,153.615,336.922z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026161993386719712050000011106365615249378448_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.9625,
    y1: 442.2796,
    x2: 160.2682,
    y2: 326.6406,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026161993386719712050000011106365615249378448_)"
    },
    d: "M165.236,334.912 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C164.276,333.485,165.088,334.058,165.236,334.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170237420480147972550000015667736459388543632_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.561,
    y1: 446.8682,
    x2: 169.8656,
    y2: 331.2315,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170237420480147972550000015667736459388543632_)"
    },
    d: "M176.857,332.903 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C175.896,331.475,176.709,332.048,176.857,332.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091736097083486311210000016978104841782022283_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.1578,
    y1: 451.4605,
    x2: 179.4635,
    y2: 335.8216,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091736097083486311210000016978104841782022283_)"
    },
    d: "M188.478,330.894 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S188.33,330.039,188.478,330.894z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039839217418453733890000002688256477429096621_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.7564,
    y1: 456.0491,
    x2: 189.0611,
    y2: 340.4123,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039839217418453733890000002688256477429096621_)"
    },
    d: "M200.099,328.884 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C199.138,327.457,199.951,328.03,200.099,328.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171704777998497472990000013967396291034978210_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.3539,
    y1: 460.6401,
    x2: 198.6588,
    y2: 345.0027,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171704777998497472990000013967396291034978210_)"
    },
    d: "M211.719,326.875 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C210.759,325.447,211.572,326.02,211.719,326.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008865644815726162020000010054249707370041519_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.0326,
    y1: 439.4413,
    x2: 154.3371,
    y2: 323.8048,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008865644815726162020000010054249707370041519_)"
    },
    d: "M155.22,346.206 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C154.26,344.778,155.073,345.351,155.22,346.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172426101991106672480000011224940465516618902_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.63,
    y1: 444.0325,
    x2: 163.935,
    y2: 328.395,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172426101991106672480000011224940465516618902_)"
    },
    d: "M166.841,344.196 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S166.693,343.342,166.841,344.196z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123428444361180978000000006490040900123323799_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.228,
    y1: 448.6224,
    x2: 173.5326,
    y2: 332.9856,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123428444361180978000000006490040900123323799_)"
    },
    d: "M178.462,342.187 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C177.502,340.759,178.314,341.332,178.462,342.187z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027565821803622367330000012066478265653299336_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.8258,
    y1: 453.2125,
    x2: 183.1304,
    y2: 337.5757,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027565821803622367330000012066478265653299336_)"
    },
    d: "M190.083,340.178 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C189.123,338.75,189.935,339.323,190.083,340.178z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005255692257538656950000010559592544553058695_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.4232,
    y1: 457.8034,
    x2: 192.7282,
    y2: 342.166,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005255692257538656950000010559592544553058695_)"
    },
    d: "M201.704,338.168 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C200.744,336.741,201.556,337.314,201.704,338.168z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171692796095908362480000000547059680563774102_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.0212,
    y1: 462.3933,
    x2: 202.3258,
    y2: 346.7566,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171692796095908362480000000547059680563774102_)"
    },
    d: "M213.325,336.159 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C212.364,334.731,213.177,335.304,213.325,336.159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101095955487386387820000010231401788235766182_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.6995,
    y1: 441.1956,
    x2: 158.0043,
    y2: 325.5585,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101095955487386387820000010231401788235766182_)"
    },
    d: "M156.826,355.49 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C155.865,354.062,156.678,354.635,156.826,355.49z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045584876194125836060000015870710206616944810_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.2969,
    y1: 445.7867,
    x2: 167.6016,
    y2: 330.1498,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045584876194125836060000015870710206616944810_)"
    },
    d: "M168.446,353.48 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C167.486,352.053,168.299,352.626,168.446,353.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028320178177544873880000014259989412419592858_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.8948,
    y1: 450.3766,
    x2: 177.1997,
    y2: 334.7393,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028320178177544873880000014259989412419592858_)"
    },
    d: "M180.067,351.471 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C179.107,350.044,179.92,350.616,180.067,351.471z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169556302918302174220000007533036786989676436_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.4927,
    y1: 454.9666,
    x2: 186.7973,
    y2: 339.3299,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169556302918302174220000007533036786989676436_)"
    },
    d: "M191.688,349.462 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C190.728,348.034,191.54,348.607,191.688,349.462z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085228263898587242130000009475421933463267760_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.0898,
    y1: 459.5584,
    x2: 196.3954,
    y2: 343.9195,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085228263898587242130000009475421933463267760_)"
    },
    d: "M203.309,347.452 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S203.161,346.598,203.309,347.452z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116233475793236594500000014516508757229591940_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.6883,
    y1: 464.1472,
    x2: 205.9929,
    y2: 348.5104,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116233475793236594500000014516508757229591940_)"
    },
    d: "M214.93,345.443 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C213.97,344.016,214.782,344.589,214.93,345.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087384702959512712550000007439289377706644667_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.3662,
    y1: 442.9502,
    x2: 161.6717,
    y2: 327.3116,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087384702959512712550000007439289377706644667_)"
    },
    d: "M158.431,364.774 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C157.471,363.346,158.283,363.919,158.431,364.774z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106135429498889080150000008997628867846540445_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.9647,
    y1: 447.5389,
    x2: 171.2688,
    y2: 331.9033,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106135429498889080150000008997628867846540445_)"
    },
    d: "M170.052,362.764 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C169.091,361.337,169.904,361.91,170.052,362.764z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121276262235499091880000007093725145237622162_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.5614,
    y1: 452.1314,
    x2: 180.8671,
    y2: 336.4925,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121276262235499091880000007093725145237622162_)"
    },
    d: "M181.673,360.755 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S181.525,359.901,181.673,360.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165207507189759372240000010798085194077532289_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.1598,
    y1: 456.7204,
    x2: 190.4644,
    y2: 341.0837,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165207507189759372240000010798085194077532289_)"
    },
    d: "M193.294,358.746 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C192.333,357.318,193.146,357.891,193.294,358.746z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087401156298627371050000000967174284250895749_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.7573,
    y1: 461.3113,
    x2: 200.0622,
    y2: 345.6739,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087401156298627371050000000967174284250895749_)"
    },
    d: "M204.914,356.737 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C203.954,355.309,204.767,355.882,204.914,356.737z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033329634147878773730000010689530564896919209_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.3552,
    y1: 465.9013,
    x2: 209.6598,
    y2: 350.2645,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033329634147878773730000010689530564896919209_)"
    },
    d: "M216.535,354.727 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C215.575,353.3,216.388,353.873,216.535,354.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049184644165576431540000007386196343542130108_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.0335,
    y1: 444.7035,
    x2: 165.3383,
    y2: 329.0663,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049184644165576431540000007386196343542130108_)"
    },
    d: "M160.036,374.058 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C159.076,372.63,159.888,373.203,160.036,374.058z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024716190658002099110000002713264091887237799_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.6314,
    y1: 449.2935,
    x2: 174.9361,
    y2: 333.6566,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024716190658002099110000002713264091887237799_)"
    },
    d: "M171.657,372.049 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C170.697,370.621,171.509,371.194,171.657,372.049z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032626596217631927630000005815126725533868726_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.229,
    y1: 453.8842,
    x2: 184.5339,
    y2: 338.2468,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032626596217631927630000005815126725533868726_)"
    },
    d: "M183.278,370.039 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C182.318,368.612,183.13,369.185,183.278,370.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075869598680741571190000000775864884889712574_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.8267,
    y1: 458.4746,
    x2: 194.1316,
    y2: 342.8373,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075869598680741571190000000775864884889712574_)"
    },
    d: "M194.899,368.03 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C193.939,366.602,194.751,367.175,194.899,368.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009558015426587278660000002989353539639467155_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.4245,
    y1: 463.0647,
    x2: 203.7292,
    y2: 347.4279,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009558015426587278660000002989353539639467155_)"
    },
    d: "M206.52,366.021 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C205.559,364.593,206.372,365.166,206.52,366.021z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075859366272776341900000003426573251479439548_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.0216,
    y1: 467.6566,
    x2: 213.3272,
    y2: 352.0177,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075859366272776341900000003426573251479439548_)"
    },
    d: "M218.141,364.011 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C217.18,362.584,217.993,363.157,218.141,364.011z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058571051597440721590000001567476770521220537_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.7007,
    y1: 446.457,
    x2: 169.0052,
    y2: 330.8205,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058571051597440721590000001567476770521220537_)"
    },
    d: "M161.641,383.342 c0.148,0.854-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C160.681,381.914,161.494,382.487,161.641,383.342z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014606455288842448730000007096478524088397452_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.2982,
    y1: 451.0479,
    x2: 178.6032,
    y2: 335.4104,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014606455288842448730000007096478524088397452_)"
    },
    d: "M173.262,381.333 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C172.302,379.905,173.115,380.478,173.262,381.333z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111870111491247894620000001216314050226553221_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.8961,
    y1: 455.638,
    x2: 188.2007,
    y2: 340.0012,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111870111491247894620000001216314050226553221_)"
    },
    d: "M184.883,379.323 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C183.923,377.896,184.735,378.469,184.883,379.323z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170275179165588535380000003044014755844595083_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.4934,
    y1: 460.2292,
    x2: 197.799,
    y2: 344.5903,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170275179165588535380000003044014755844595083_)"
    },
    d: "M196.504,377.314 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C195.544,375.886,196.356,376.459,196.504,377.314z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159450034675664197330000005748138595039215502_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.092,
    y1: 464.8178,
    x2: 207.396,
    y2: 349.1823,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159450034675664197330000005748138595039215502_)"
    },
    d: "M208.125,375.305 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C207.165,373.877,207.977,374.45,208.125,375.305z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092436195109606319880000003187382483162571181_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.6887,
    y1: 469.4103,
    x2: 216.9943,
    y2: 353.7714,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092436195109606319880000003187382483162571181_)"
    },
    d: "M219.746,373.295 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S219.598,372.441,219.746,373.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181767636923623280550000013683602692030818466_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.368,
    y1: 448.2104,
    x2: 172.6718,
    y2: 332.5753,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181767636923623280550000013683602692030818466_)"
    },
    d: "M163.247,392.626 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C162.286,391.199,163.099,391.772,163.247,392.626z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047027253088353186660000018045768471140630948_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.965,
    y1: 452.8023,
    x2: 182.2707,
    y2: 337.1632,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047027253088353186660000018045768471140630948_)"
    },
    d: "M174.868,390.617 c0.148,0.855-0.425,1.667-1.28,1.815s-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S174.72,389.762,174.868,390.617z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103240671812970345400000002930525939422997414_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.5631,
    y1: 457.3918,
    x2: 191.8678,
    y2: 341.755,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103240671812970345400000002930525939422997414_)"
    },
    d: "M186.489,388.607 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C185.528,387.18,186.341,387.753,186.489,388.607z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110464799129435817380000017798047996029358491_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.1607,
    y1: 461.9825,
    x2: 201.4656,
    y2: 346.3452,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110464799129435817380000017798047996029358491_)"
    },
    d: "M198.109,386.598 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S197.962,385.743,198.109,386.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028316007056989683710000000394878816842232486_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.7587,
    y1: 466.5724,
    x2: 211.0633,
    y2: 350.9356,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028316007056989683710000000394878816842232486_)"
    },
    d: "M209.73,384.589 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C208.77,383.161,209.583,383.734,209.73,384.589z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155148174831214933790000015743744096618257584_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.3562,
    y1: 471.1631,
    x2: 220.6611,
    y2: 355.5258,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155148174831214933790000015743744096618257584_)"
    },
    d: "M221.351,382.579 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C220.391,381.152,221.203,381.725,221.351,382.579z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000154416639521030945480000002270041072034834596_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067954341407539760180000007423244673253264036_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.8345,
    y1: 298.0722,
    x2: 418.1383,
    y2: 182.4371,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067954341407539760180000007423244673253264036_)"
    },
    d: "M393.388,153.769 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C392.428,152.342,393.24,152.915,393.388,153.769z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034784138108268752720000009616912690551907239_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.431,
    y1: 302.665,
    x2: 427.7366,
    y2: 187.0264,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034784138108268752720000009616912690551907239_)"
    },
    d: "M405.009,151.76 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C404.049,150.332,404.861,150.905,405.009,151.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100349966667536325210000013820758005701028508_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0295,
    y1: 307.2538,
    x2: 437.334,
    y2: 191.6173,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100349966667536325210000013820758005701028508_)"
    },
    d: "M416.63,149.75 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C415.67,148.323,416.482,148.896,416.63,149.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063604541124933298300000005870109168057569950_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.6269,
    y1: 311.845,
    x2: 446.9318,
    y2: 196.2076,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063604541124933298300000005870109168057569950_)"
    },
    d: "M428.251,147.741 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C427.29,146.314,428.103,146.887,428.251,147.741z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137104270261347597520000015238929360089224624_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.2248,
    y1: 316.435,
    x2: 456.5295,
    y2: 200.7981,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137104270261347597520000015238929360089224624_)"
    },
    d: "M439.872,145.732 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C438.911,144.304,439.724,144.877,439.872,145.732z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091735110908687708030000001140375658450961589_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.8225,
    y1: 321.0252,
    x2: 466.1272,
    y2: 205.3885,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091735110908687708030000001140375658450961589_)"
    },
    d: "M451.493,143.722 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C450.532,142.295,451.345,142.868,451.493,143.722z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098215336641363736080000002668219904811271063_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.5011,
    y1: 299.8271,
    x2: 421.8055,
    y2: 184.1906,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098215336641363736080000002668219904811271063_)"
    },
    d: "M394.993,163.053 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C394.033,161.626,394.846,162.199,394.993,163.053z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098200905771776044040000016101047846230528664_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.0985,
    y1: 304.4179,
    x2: 431.4034,
    y2: 188.7808,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098200905771776044040000016101047846230528664_)"
    },
    d: "M406.614,161.044 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C405.654,159.616,406.467,160.189,406.614,161.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044869324935698576670000010493447802911600815_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.6963,
    y1: 309.0084,
    x2: 441.001,
    y2: 193.3713,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044869324935698576670000010493447802911600815_)"
    },
    d: "M418.235,159.035 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C417.275,157.607,418.087,158.18,418.235,159.035z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136371948455134762310000017367273642472773821_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.2942,
    y1: 313.5984,
    x2: 450.5988,
    y2: 197.9615,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136371948455134762310000017367273642472773821_)"
    },
    d: "M429.856,157.025 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C428.896,155.598,429.708,156.171,429.856,157.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091712601229620243240000008126170885335985087_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.8916,
    y1: 318.1893,
    x2: 460.1966,
    y2: 202.5518,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091712601229620243240000008126170885335985087_)"
    },
    d: "M441.477,155.016 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C440.517,153.588,441.329,154.161,441.477,155.016z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020357094894554457930000002734989421282795652_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.4896,
    y1: 322.7791,
    x2: 469.7943,
    y2: 207.1423,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020357094894554457930000002734989421282795652_)"
    },
    d: "M453.098,153.007 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C452.138,151.579,452.95,152.152,453.098,153.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147928502186253840300000000798855648152719792_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.1679,
    y1: 301.5813,
    x2: 425.4727,
    y2: 185.9442,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147928502186253840300000000798855648152719792_)"
    },
    d: "M396.599,172.337 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C395.638,170.91,396.451,171.483,396.599,172.337z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077326785084530813720000006119746800489262737_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.7654,
    y1: 306.1722,
    x2: 435.0699,
    y2: 190.5357,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077326785084530813720000006119746800489262737_)"
    },
    d: "M408.22,170.328 c0.148,0.854-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C407.259,168.9,408.072,169.473,408.22,170.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009579722718816568730000017603724840844643769_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.3628,
    y1: 310.7632,
    x2: 444.6683,
    y2: 195.1246,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009579722718816568730000017603724840844643769_)"
    },
    d: "M419.84,168.319 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C418.88,166.891,419.693,167.464,419.84,168.319z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070119787586964049730000014868435639239307394_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.9615,
    y1: 315.3515,
    x2: 454.2656,
    y2: 199.7159,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070119787586964049730000014868435639239307394_)"
    },
    d: "M431.461,166.309 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C430.501,164.882,431.314,165.455,431.461,166.309z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128486944497738133720000009554155165710458040_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.5581,
    y1: 319.9443,
    x2: 463.8639,
    y2: 204.3052,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128486944497738133720000009554155165710458040_)"
    },
    d: "M443.082,164.3 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 S442.935,163.445,443.082,164.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146487811066897505670000006949854473179111832_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.1567,
    y1: 324.5329,
    x2: 473.4613,
    y2: 208.8961,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146487811066897505670000006949854473179111832_)"
    },
    d: "M454.703,162.29 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C453.743,160.863,454.555,161.436,454.703,162.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025403499380774975170000002688883604256680066_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.8346,
    y1: 303.3359,
    x2: 429.1401,
    y2: 187.6973,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025403499380774975170000002688883604256680066_)"
    },
    d: "M398.204,181.621 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C397.244,180.194,398.056,180.767,398.204,181.621z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114054148667886218530000010042394056802728604_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.4329,
    y1: 307.9252,
    x2: 438.7374,
    y2: 192.2887,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114054148667886218530000010042394056802728604_)"
    },
    d: "M409.825,179.612 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C408.865,178.184,409.677,178.758,409.825,179.612z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000937298370366746280000017672394322278589104_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.0304,
    y1: 312.5159,
    x2: 448.3352,
    y2: 196.8789,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000937298370366746280000017672394322278589104_)"
    },
    d: "M421.446,177.603 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C420.485,176.175,421.298,176.748,421.446,177.603z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080195377102522016910000013364587354878785156_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.6281,
    y1: 317.1063,
    x2: 457.9329,
    y2: 201.4694,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080195377102522016910000013364587354878785156_)"
    },
    d: "M433.067,175.593 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C432.106,174.166,432.919,174.739,433.067,175.593z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009552985595504848360000001281757149467091373_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.2256,
    y1: 321.6972,
    x2: 467.5306,
    y2: 206.0596,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009552985595504848360000001281757149467091373_)"
    },
    d: "M444.688,173.584 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C443.727,172.156,444.54,172.729,444.688,173.584z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180343537853737955690000007100037875850589624_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.8234,
    y1: 326.2875,
    x2: 477.1283,
    y2: 210.6501,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180343537853737955690000007100037875850589624_)"
    },
    d: "M456.309,171.575 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C455.348,170.147,456.161,170.72,456.309,171.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114048255622097791850000015380282770421144480_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.502,
    y1: 305.0892,
    x2: 432.8067,
    y2: 189.4521,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114048255622097791850000015380282770421144480_)"
    },
    d: "M399.809,190.906 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C398.849,189.478,399.662,190.051,399.809,190.906z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087405624048776690280000005812315452036818346_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.0998,
    y1: 309.6794,
    x2: 442.4045,
    y2: 194.0423,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087405624048776690280000005812315452036818346_)"
    },
    d: "M411.43,188.896 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C410.47,187.469,411.283,188.042,411.43,188.896z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054254263501116728630000014859148765000741290_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.6976,
    y1: 314.2695,
    x2: 452.0021,
    y2: 198.633,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054254263501116728630000014859148765000741290_)"
    },
    d: "M423.051,186.887 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C422.091,185.459,422.903,186.032,423.051,186.887z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003068569830904402270000008682715387309354908_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.295,
    y1: 318.8605,
    x2: 461.6,
    y2: 203.223,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003068569830904402270000008682715387309354908_)"
    },
    d: "M434.672,184.877 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C433.712,183.45,434.524,184.023,434.672,184.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104666898201939631890000018320932445246239110_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.8929,
    y1: 323.4506,
    x2: 471.1976,
    y2: 207.8136,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104666898201939631890000018320932445246239110_)"
    },
    d: "M446.293,182.868 c0.148,0.854-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C445.333,181.441,446.145,182.014,446.293,182.868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164475155823840468450000007886164521104037773_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.49,
    y1: 328.0423,
    x2: 480.7956,
    y2: 212.4034,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164475155823840468450000007886164521104037773_)"
    },
    d: "M457.914,180.859 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28s0.425-1.667,1.28-1.815 C456.953,179.431,457.766,180.004,457.914,180.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005251664555733967870000014472077675372066222_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.1691,
    y1: 306.8428,
    x2: 436.4736,
    y2: 191.2063,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005251664555733967870000014472077675372066222_)"
    },
    d: "M401.415,200.19 c0.148,0.854-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C400.454,198.762,401.267,199.335,401.415,200.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021085979796046860190000013210402899976324282_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.7664,
    y1: 311.4341,
    x2: 446.0719,
    y2: 195.7955,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021085979796046860190000013210402899976324282_)"
    },
    d: "M413.035,198.18 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C412.075,196.753,412.888,197.326,413.035,198.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031199464711281682600000010931511891249862576_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.3649,
    y1: 316.0229,
    x2: 455.6687,
    y2: 200.3878,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031199464711281682600000010931511891249862576_)"
    },
    d: "M424.656,196.171 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C423.696,194.743,424.509,195.316,424.656,196.171z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065792061285468793140000015585669068737042581_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.9619,
    y1: 320.6148,
    x2: 465.2674,
    y2: 204.9762,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065792061285468793140000015585669068737042581_)"
    },
    d: "M436.277,194.161 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C435.317,192.734,436.13,193.307,436.277,194.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065783773947979151670000003513394474165112454_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.56,
    y1: 325.2044,
    x2: 474.8647,
    y2: 209.5674,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065783773947979151670000003513394474165112454_)"
    },
    d: "M447.898,192.152 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C446.938,190.725,447.75,191.298,447.898,192.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145767132589152262930000003348522597025861280_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.1576,
    y1: 329.7951,
    x2: 484.4625,
    y2: 214.1577,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145767132589152262930000003348522597025861280_)"
    },
    d: "M459.519,190.143 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C458.559,188.715,459.371,189.288,459.519,190.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049918185367119206390000006183793771097294518_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.8362,
    y1: 308.5966,
    x2: 440.1407,
    y2: 192.9601,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049918185367119206390000006183793771097294518_)"
    },
    d: "M403.02,209.474 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.854,0.425-1.667,1.28-1.815 C402.06,208.046,402.872,208.619,403.02,209.474z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010272083077708450410000003164923393728502420_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.4335,
    y1: 313.1878,
    x2: 449.739,
    y2: 197.5492,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010272083077708450410000003164923393728502420_)"
    },
    d: "M414.641,207.464 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C413.68,206.037,414.493,206.61,414.641,207.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045581459444642450330000004418180293410517421_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.0316,
    y1: 317.7774,
    x2: 459.3361,
    y2: 202.1409,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045581459444642450330000004418180293410517421_)"
    },
    d: "M426.262,205.455 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C425.301,204.027,426.114,204.6,426.262,205.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018931253153737253940000013035106677475174800_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.6292,
    y1: 322.3681,
    x2: 468.934,
    y2: 206.731,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018931253153737253940000013035106677475174800_)"
    },
    d: "M437.883,203.446 c0.148,0.855-0.425,1.667-1.28,1.815c-0.854,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C436.922,202.018,437.735,202.591,437.883,203.446z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088852349279430203880000013532247121353602229_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.2269,
    y1: 326.9585,
    x2: 478.5319,
    y2: 211.321,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088852349279430203880000013532247121353602229_)"
    },
    d: "M449.503,201.436 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C448.543,200.009,449.356,200.582,449.503,201.436z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086672789801008314660000018007448519657318302_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.8248,
    y1: 331.5485,
    x2: 488.1294,
    y2: 215.9118,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086672789801008314660000018007448519657318302_)"
    },
    d: "M461.124,199.427 c0.148,0.855-0.425,1.667-1.28,1.815c-0.855,0.148-1.667-0.425-1.815-1.28c-0.148-0.855,0.425-1.667,1.28-1.815 C460.164,197.999,460.977,198.572,461.124,199.427z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117638533101425431750000014478153663883746434_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.2624,
    y1: 384.0961,
    x2: 115.9043,
    y2: 0.0966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117638533101425431750000014478153663883746434_)"
    },
    d: "M231.898,298.595L127.723,316.33 c-4.068,0.693-7.927-2.044-8.619-6.111L85.82,114.711c-0.692-4.068,2.044-7.927,6.112-8.619l104.174-17.735 c4.068-0.692,7.927,2.044,8.619,6.112l33.284,195.508C238.702,294.043,235.966,297.903,231.898,298.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.688,284.741l-98.633,16.792c-3.668,0.624-7.147-1.843-7.772-5.511L91.63,127.718 c-0.624-3.668,1.843-7.147,5.51-7.772l98.633-16.792c3.668-0.624,7.147,1.843,7.772,5.511l28.653,168.304 C232.823,280.637,230.356,284.116,226.688,284.741z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072987319559263319310000006967149262567658881_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.6311,
    y1: 292.32,
    x2: 186.9766,
    y2: 351.891,
    gradientTransform: "matrix(0.9982 -0.0602 0.0602 0.9982 -15.5128 4.4907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000072987319559263319310000006967149262567658881_)"
    },
    d: "M185.82,300.906 l-12.121,2.033c-1.293,0.217-2.517-0.656-2.734-1.949l0,0c-0.217-1.293,0.656-2.517,1.949-2.734l12.121-2.033 c1.293-0.217,2.517,0.656,2.734,1.949l0,0C187.985,299.465,187.113,300.689,185.82,300.906z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181784964602389035010000001393268964866797715_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.4198,
    y1: 270.4869,
    x2: 161.7781,
    y2: 196.9125,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000181784964602389035010000001393268964866797715_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: " M214.26,235.717l-90.446,15.639c-1.474,0.255-2.875-0.733-3.13-2.207l-8.877-51.337c-0.255-1.474,0.733-2.875,2.207-3.13 l90.446-15.639c1.474-0.255,2.876,0.733,3.13,2.207l8.877,51.337C216.722,234.06,215.734,235.462,214.26,235.717z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115482099476991729130000001504220172059338668_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.3725,
    y1: 233.2886,
    x2: 217.5178,
    y2: 233.2886,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000115482099476991729130000001504220172059338668_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 112.453,
    y1: 195.551,
    x2: 216.364,
    y2: 233.918
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085936546292953861050000015776395097030189226_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.5296,
    y1: 233.9835,
    x2: 217.2714,
    y2: 233.9835,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000085936546292953861050000015776395097030189226_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 206.737,
    y1: 179.704,
    x2: 122.229,
    y2: 251.15
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9854 -0.1704 0.1704 0.9854 128.4293 150.2615)",
    style: {
      fill: "#DCE9FF",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "7.0529px"
    }
  }, "Upload Image"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010289821056539615030000011138108231048789896_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.5475,
    y1: 142.5351,
    x2: 169.8045,
    y2: 239.9472,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5666E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52CDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010289821056539615030000011138108231048789896_)"
    },
    d: "M163.834,166.798l-5.665,9.596 c-0.301,0.51-0.987,0.628-1.441,0.249l-8.558-7.137c-0.628-0.524-0.355-1.544,0.451-1.683l1.654-0.286 c0.522-0.09,0.873-0.587,0.782-1.109l-1.618-9.355c-0.09-0.522,0.26-1.019,0.782-1.109l7.132-1.233 c0.522-0.09,1.019,0.26,1.109,0.782l1.618,9.355c0.09,0.522,0.587,0.873,1.109,0.782l1.654-0.286 C163.651,165.225,164.25,166.093,163.834,166.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123407180805678335050000013788799729696474515_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.9604,
    y1: 255.7244,
    x2: 119.2488,
    y2: 295.946,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123407180805678335050000013788799729696474515_)"
    },
    d: "M134.987,265.473 c0.532,3.078-1.532,6.005-4.61,6.537c-3.078,0.532-6.005-1.532-6.537-4.61c-0.532-3.078,1.532-6.005,4.61-6.537 C131.528,260.331,134.455,262.395,134.987,265.473z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012449719960104472080000018340954414435490436_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.74,
    y1: 278.2711,
    x2: 197.3492,
    y2: 278.2711,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000012449719960104472080000018340954414435490436_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 142.802,
    y1: 264.122,
    x2: 199.57,
    y2: 254.306
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182511675355255546290000018218516426552387988_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.7399,
    y1: 282.7669,
    x2: 181.8469,
    y2: 282.7669,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000182511675355255546290000018218516426552387988_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 143.568,
    y1: 268.552,
    x2: 185.06,
    y2: 261.378
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173122297530985626020000004642586874532284824_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.7399,
    y1: 287.263,
    x2: 197.3489,
    y2: 287.263,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000173122297530985626020000004642586874532284824_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 144.334,
    y1: 272.982,
    x2: 201.102,
    y2: 263.167
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150802087249952291900000006195795061349155976_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.7398,
    y1: 291.7586,
    x2: 163.9356,
    y2: 291.7586,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000150802087249952291900000006195795061349155976_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 145.1,
    y1: 277.413,
    x2: 168.943,
    y2: 273.29
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041995470777524211720000013858657969688002487_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.4344,
    y1: 121.9847,
    x2: 158.4764,
    y2: 217.2309,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041995470777524211720000013858657969688002487_)"
    },
    d: "M98.336,128.711 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C97.813,127.933,98.255,128.245,98.336,128.711z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129922468117601964630000012573474572200516021_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.5557,
    y1: 119.4017,
    x2: 163.5977,
    y2: 214.6477,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129922468117601964630000012573474572200516021_)"
    },
    d: "M104.666,127.616 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C104.143,126.839,104.586,127.151,104.666,127.616z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059302223986088340130000012667972300531614636_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.6771,
    y1: 116.8187,
    x2: 168.7191,
    y2: 212.0648,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059302223986088340130000012667972300531614636_)"
    },
    d: "M110.997,126.522 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C110.473,125.744,110.916,126.056,110.997,126.522z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107568555602084375880000014848385008868857496_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.7984,
    y1: 114.2356,
    x2: 173.8404,
    y2: 209.4817,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107568555602084375880000014848385008868857496_)"
    },
    d: "M117.327,125.427 c0.08,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C116.804,124.649,117.247,124.961,117.327,125.427z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168819566234966267000000003310561389031933611_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.9197,
    y1: 111.6524,
    x2: 178.9617,
    y2: 206.8985,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168819566234966267000000003310561389031933611_)"
    },
    d: "M123.658,124.332 c0.081,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C123.134,123.555,123.577,123.867,123.658,124.332z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035507134747937886350000010858303038782887329_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.0411,
    y1: 109.0694,
    x2: 184.0831,
    y2: 204.3155,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035507134747937886350000010858303038782887329_)"
    },
    d: "M129.988,123.238 c0.08,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C129.465,122.46,129.908,122.772,129.988,123.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117652860024960850310000015776149358848481455_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.3704,
    y1: 123.0255,
    x2: 156.4131,
    y2: 218.2729,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117652860024960850310000015776149358848481455_)"
    },
    d: "M99.21,133.768 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C98.687,132.991,99.13,133.303,99.21,133.768z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183955932287726729200000016973914196872063663_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.4916,
    y1: 120.442,
    x2: 161.5349,
    y2: 215.6908,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183955932287726729200000016973914196872063663_)"
    },
    d: "M105.541,132.674 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C105.017,131.896,105.46,132.208,105.541,132.674z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005945089784784071070000011022156990093963959_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.6129,
    y1: 117.859,
    x2: 166.6563,
    y2: 213.1077,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005945089784784071070000011022156990093963959_)"
    },
    d: "M111.871,131.579 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C111.348,130.801,111.791,131.114,111.871,131.579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134249757081565572780000018197689867140431250_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.7343,
    y1: 115.2759,
    x2: 171.7774,
    y2: 210.5243,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134249757081565572780000018197689867140431250_)"
    },
    d: "M118.202,130.484 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C117.678,129.707,118.121,130.019,118.202,130.484z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072986030720909227740000016054576710985291909_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.8554,
    y1: 112.6924,
    x2: 176.8992,
    y2: 207.9421,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072986030720909227740000016054576710985291909_)"
    },
    d: "M124.532,129.39 c0.08,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C124.009,128.612,124.452,128.924,124.532,129.39z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070819758823839032190000001770023512620753539_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.9767,
    y1: 110.1092,
    x2: 182.0204,
    y2: 205.3588,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070819758823839032190000001770023512620753539_)"
    },
    d: "M130.863,128.295 c0.081,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C130.339,127.518,130.782,127.83,130.863,128.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131345095634777955740000011600816033854747295_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.3065,
    y1: 124.0662,
    x2: 154.3494,
    y2: 219.3142,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131345095634777955740000011600816033854747295_)"
    },
    d: "M100.085,138.826 c0.08,0.465-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989S100.004,138.36,100.085,138.826z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111879778816687993210000007644012646854245044_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.4278,
    y1: 121.483,
    x2: 159.4711,
    y2: 216.7318,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111879778816687993210000007644012646854245044_)"
    },
    d: "M106.415,137.731 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C105.892,136.954,106.335,137.266,106.415,137.731z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019640423355793581290000002043566729241468349_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.5491,
    y1: 118.8998,
    x2: 164.5924,
    y2: 214.1486,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019640423355793581290000002043566729241468349_)"
    },
    d: "M112.746,136.637 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C112.222,135.859,112.665,136.171,112.746,136.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150812389062887743060000003606099326230975410_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.6704,
    y1: 116.3167,
    x2: 169.7137,
    y2: 211.5655,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150812389062887743060000003606099326230975410_)"
    },
    d: "M119.076,135.542 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C118.553,134.764,118.996,135.077,119.076,135.542z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093884863252116383950000016735674612202187912_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.7919,
    y1: 113.7339,
    x2: 174.8346,
    y2: 208.9816,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093884863252116383950000016735674612202187912_)"
    },
    d: "M125.407,134.447 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C124.883,133.67,125.326,133.982,125.407,134.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118355465046875819200000007029149282697335215_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.9129,
    y1: 111.1503,
    x2: 179.9563,
    y2: 206.3991,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118355465046875819200000007029149282697335215_)"
    },
    d: "M131.737,133.353 c0.081,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C131.214,132.575,131.657,132.887,131.737,133.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080185727862815658270000017022585893738854839_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.2431,
    y1: 125.1081,
    x2: 152.2847,
    y2: 220.3533,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080185727862815658270000017022585893738854839_)"
    },
    d: "M100.959,143.883 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C100.436,143.106,100.879,143.418,100.959,143.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103943401025933293870000016267739837924878765_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.3644,
    y1: 122.5249,
    x2: 157.406,
    y2: 217.7702,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103943401025933293870000016267739837924878765_)"
    },
    d: "M107.29,142.789 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 S107.209,142.323,107.29,142.789z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132057710698681225290000013001649031595316116_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.4857,
    y1: 119.9416,
    x2: 162.5276,
    y2: 215.1876,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132057710698681225290000013001649031595316116_)"
    },
    d: "M113.62,141.694 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C113.097,140.917,113.54,141.229,113.62,141.694z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103967935394067903170000015195961301287269523_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.607,
    y1: 117.3586,
    x2: 167.649,
    y2: 212.6047,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103967935394067903170000015195961301287269523_)"
    },
    d: "M119.951,140.6 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C119.427,139.822,119.87,140.134,119.951,140.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106858785914453023590000011794023756922156963_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.7283,
    y1: 114.7755,
    x2: 172.7703,
    y2: 210.0215,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106858785914453023590000011794023756922156963_)"
    },
    d: "M126.281,139.505 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C125.758,138.727,126.201,139.039,126.281,139.505z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132075417581434675630000001463108986189272219_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.85,
    y1: 112.193,
    x2: 177.8913,
    y2: 207.4379,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132075417581434675630000001463108986189272219_)"
    },
    d: "M132.612,138.41 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C132.089,137.633,132.531,137.945,132.612,138.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092421984772385016990000008156020702782202031_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.1793,
    y1: 126.149,
    x2: 150.2209,
    y2: 221.3943,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092421984772385016990000008156020702782202031_)"
    },
    d: "M101.834,148.941 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 S101.753,148.475,101.834,148.941z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029016123989543744040000014461153521974748847_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.3006,
    y1: 123.5659,
    x2: 155.3422,
    y2: 218.8112,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029016123989543744040000014461153521974748847_)"
    },
    d: "M108.164,147.846 c0.081,0.465-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C107.641,147.069,108.084,147.381,108.164,147.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170961383056624400160000009272500497796741788_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.422,
    y1: 120.983,
    x2: 160.4636,
    y2: 216.2282,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170961383056624400160000009272500497796741788_)"
    },
    d: "M114.495,146.752 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C113.971,145.974,114.414,146.286,114.495,146.752z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021092324688650387190000011963692696867726494_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.5432,
    y1: 118.3995,
    x2: 165.5852,
    y2: 213.6456,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021092324688650387190000011963692696867726494_)"
    },
    d: "M120.825,145.657 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C120.302,144.879,120.745,145.191,120.825,145.657z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168839741197276875000000004345555364262336663_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.6646,
    y1: 115.8165,
    x2: 170.7066,
    y2: 211.0626,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168839741197276875000000004345555364262336663_)"
    },
    d: "M127.156,144.563 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C126.632,143.785,127.075,144.097,127.156,144.563z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059303409957281949820000015880502601095296903_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.7859,
    y1: 113.2334,
    x2: 175.8279,
    y2: 208.4795,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059303409957281949820000015880502601095296903_)"
    },
    d: "M133.486,143.468 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C132.963,142.69,133.406,143.002,133.486,143.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138570756898093679310000016760858569645162637_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.1151,
    y1: 127.1892,
    x2: 148.1578,
    y2: 222.4366,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138570756898093679310000016760858569645162637_)"
    },
    d: "M102.708,153.998 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C102.185,153.221,102.628,153.533,102.708,153.998z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174604364935489812070000010696665234373863834_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.2364,
    y1: 124.606,
    x2: 153.2793,
    y2: 219.854,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174604364935489812070000010696665234373863834_)"
    },
    d: "M109.039,152.904 c0.08,0.465-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C108.515,152.126,108.958,152.438,109.039,152.904z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120544399957063647180000002085101096624312724_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3577,
    y1: 122.0228,
    x2: 158.4006,
    y2: 217.2708,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120544399957063647180000002085101096624312724_)"
    },
    d: "M115.369,151.809 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 S115.289,151.344,115.369,151.809z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166661897175502879840000017102545590853606043_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.4789,
    y1: 119.4396,
    x2: 163.5219,
    y2: 214.6876,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166661897175502879840000017102545590853606043_)"
    },
    d: "M121.7,150.715 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C121.176,149.937,121.619,150.249,121.7,150.715z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162353127414754687050000001083005189557023916_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.6001,
    y1: 116.8562,
    x2: 168.6434,
    y2: 212.105,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162353127414754687050000001083005189557023916_)"
    },
    d: "M128.03,149.62 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C127.507,148.842,127.95,149.154,128.03,149.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149367801831053397960000013655097845532664210_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.7214,
    y1: 114.273,
    x2: 173.7647,
    y2: 209.5218,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149367801831053397960000013655097845532664210_)"
    },
    d: "M134.361,148.525 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C133.837,147.748,134.28,148.06,134.361,148.525z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054953859225243843050000012636864859649074588_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.0511,
    y1: 128.2299,
    x2: 146.0941,
    y2: 223.4779,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054953859225243843050000012636864859649074588_)"
    },
    d: "M103.582,159.056 c0.081,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C103.059,158.278,103.502,158.59,103.582,159.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132769951422567953530000003948054333056057241_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.1723,
    y1: 125.6465,
    x2: 151.2157,
    y2: 220.8953,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132769951422567953530000003948054333056057241_)"
    },
    d: "M109.913,157.961 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C109.39,157.184,109.833,157.496,109.913,157.961z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044154225968197034820000012438503043735501746_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.2936,
    y1: 123.0633,
    x2: 156.3369,
    y2: 218.3121,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044154225968197034820000012438503043735501746_)"
    },
    d: "M116.244,156.867 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C115.72,156.089,116.163,156.401,116.244,156.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156566996576051115130000008413419179345493138_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.4149,
    y1: 120.4802,
    x2: 161.4583,
    y2: 215.729,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156566996576051115130000008413419179345493138_)"
    },
    d: "M122.574,155.772 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C122.051,154.995,122.494,155.307,122.574,155.772z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004547365090617051160000004533851406783285425_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.5362,
    y1: 117.897,
    x2: 166.5795,
    y2: 213.1458,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004547365090617051160000004533851406783285425_)"
    },
    d: "M128.905,154.678 c0.08,0.466-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697s0.232-0.908,0.697-0.989 C128.381,153.9,128.824,154.212,128.905,154.678z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050623291689252589810000006653928520566950530_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.6576,
    y1: 115.314,
    x2: 171.7009,
    y2: 210.5627,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050623291689252589810000006653928520566950530_)"
    },
    d: "M135.235,153.583 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C134.712,152.805,135.155,153.117,135.235,153.583z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015333748594438554880000011044128140769623206_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.8932,
    y1: 256.584,
    x2: 224.9351,
    y2: 351.83,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015333748594438554880000011044128140769623206_)"
    },
    d: "M186.76,250.02 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C186.237,249.243,186.679,249.555,186.76,250.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111172323019986112260000007842907344607224218_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.0145,
    y1: 254.0009,
    x2: 230.0565,
    y2: 349.2469,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111172323019986112260000007842907344607224218_)"
    },
    d: "M193.09,248.926 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C192.567,248.148,193.01,248.46,193.09,248.926z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182524951211495344970000000782305121635504053_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.1359,
    y1: 251.4179,
    x2: 235.1779,
    y2: 346.664,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182524951211495344970000000782305121635504053_)"
    },
    d: "M199.421,247.831 c0.081,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C198.898,247.053,199.34,247.365,199.421,247.831z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029742728352418975350000007842861700643136927_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.2572,
    y1: 248.8348,
    x2: 240.2991,
    y2: 344.0808,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029742728352418975350000007842861700643136927_)"
    },
    d: "M205.751,246.736 c0.08,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C205.228,245.959,205.671,246.271,205.751,246.736z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158750232002540305770000008466631778210566531_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3785,
    y1: 246.2516,
    x2: 245.4205,
    y2: 341.4977,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158750232002540305770000008466631778210566531_)"
    },
    d: "M212.082,245.642 c0.081,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C211.559,244.864,212.001,245.176,212.082,245.642z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088092695845172692880000006511928887477154702_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5,
    y1: 243.6689,
    x2: 250.5416,
    y2: 338.9142,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088092695845172692880000006511928887477154702_)"
    },
    d: "M218.412,244.547 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C217.889,243.77,218.332,244.082,218.412,244.547z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069397897877640723790000008292197855790090133_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.8294,
    y1: 257.625,
    x2: 222.8713,
    y2: 352.871,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069397897877640723790000008292197855790090133_)"
    },
    d: "M187.634,255.078 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C187.111,254.3,187.554,254.612,187.634,255.078z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075127969542830394210000012632661264236235402_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.9507,
    y1: 255.0418,
    x2: 227.9926,
    y2: 350.2879,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075127969542830394210000012632661264236235402_)"
    },
    d: "M193.965,253.983 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C193.442,253.206,193.884,253.518,193.965,253.983z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062193212752339851380000011380165195276946831_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.0721,
    y1: 252.4589,
    x2: 233.114,
    y2: 347.7049,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062193212752339851380000011380165195276946831_)"
    },
    d: "M200.295,252.889 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C199.772,252.111,200.215,252.423,200.295,252.889z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081636391300179526750000001017477404462662048_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.1934,
    y1: 249.8757,
    x2: 238.2353,
    y2: 345.1218,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081636391300179526750000001017477404462662048_)"
    },
    d: "M206.626,251.794 c0.081,0.465-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C206.103,251.016,206.545,251.328,206.626,251.794z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106827628375225275090000007076663869115977377_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.3148,
    y1: 247.2928,
    x2: 243.3567,
    y2: 342.5388,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106827628375225275090000007076663869115977377_)"
    },
    d: "M212.956,250.699 c0.08,0.465-0.232,0.908-0.697,0.989c-0.466,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C212.433,249.922,212.876,250.234,212.956,250.699z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080895370312085320120000009381215473130247854_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.4361,
    y1: 244.7096,
    x2: 248.478,
    y2: 339.9557,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080895370312085320120000009381215473130247854_)"
    },
    d: "M219.287,249.605 c0.081,0.465-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C218.764,248.827,219.206,249.139,219.287,249.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150099665142235578850000004720538960776038573_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.7654,
    y1: 258.6656,
    x2: 220.808,
    y2: 353.913,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150099665142235578850000004720538960776038573_)"
    },
    d: "M188.509,260.135 c0.081,0.465-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C187.986,259.358,188.428,259.67,188.509,260.135z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031183868798568243500000011866636056752582303_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.8866,
    y1: 256.0822,
    x2: 225.9299,
    y2: 351.331,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031183868798568243500000011866636056752582303_)"
    },
    d: "M194.839,259.041 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C194.316,258.263,194.759,258.575,194.839,259.041z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128468104845406879650000002428250351029282704_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.0079,
    y1: 253.499,
    x2: 231.0512,
    y2: 348.7478,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128468104845406879650000002428250351029282704_)"
    },
    d: "M201.17,257.946 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C200.647,257.168,201.089,257.481,201.17,257.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083808250105661264480000009736458950520985269_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.1292,
    y1: 250.916,
    x2: 236.1725,
    y2: 346.1647,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083808250105661264480000009736458950520985269_)"
    },
    d: "M207.5,256.852 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C206.977,256.074,207.42,256.386,207.5,256.852z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083800198602941013410000004223625234619354041_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.2505,
    y1: 248.3328,
    x2: 241.2938,
    y2: 343.5815,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083800198602941013410000004223625234619354041_)"
    },
    d: "M213.831,255.757 c0.081,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C213.308,254.979,213.75,255.291,213.831,255.757z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129207098356513302390000015564843300603116982_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.3717,
    y1: 245.7496,
    x2: 246.415,
    y2: 340.9983,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129207098356513302390000015564843300603116982_)"
    },
    d: "M220.161,254.662 c0.08,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C219.638,253.885,220.081,254.197,220.161,254.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066489678052689160030000014901321100489951928_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.7019,
    y1: 259.7073,
    x2: 218.7435,
    y2: 354.9526,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066489678052689160030000014901321100489951928_)"
    },
    d: "M189.383,265.193 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 S189.303,264.727,189.383,265.193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031886780835650934430000017668296325270000027_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.8228,
    y1: 257.1233,
    x2: 223.8658,
    y2: 352.3714,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031886780835650934430000017668296325270000027_)"
    },
    d: "M195.714,264.098 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C195.191,263.321,195.633,263.633,195.714,264.098z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163795486810587500640000006112383740987957918_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.9441,
    y1: 254.5401,
    x2: 228.987,
    y2: 349.7881,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163795486810587500640000006112383740987957918_)"
    },
    d: "M202.044,263.004 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C201.521,262.226,201.964,262.538,202.044,263.004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101075549843633948720000012049627443342691724_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.0655,
    y1: 251.9571,
    x2: 234.1084,
    y2: 347.2051,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101075549843633948720000012049627443342691724_)"
    },
    d: "M208.375,261.909 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C207.852,261.131,208.294,261.444,208.375,261.909z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018938928717883581160000017855145901971515294_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.187,
    y1: 249.3744,
    x2: 239.2293,
    y2: 344.6212,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018938928717883581160000017855145901971515294_)"
    },
    d: "M214.705,260.814 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C214.182,260.037,214.625,260.349,214.705,260.814z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050664779468119528250000008222548227418766208_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.3078,
    y1: 246.7902,
    x2: 244.3515,
    y2: 342.0398,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050664779468119528250000008222548227418766208_)"
    },
    d: "M221.036,259.72 c0.08,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C220.513,258.942,220.955,259.254,221.036,259.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165952721850058682790000002565372024273012911_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.6381,
    y1: 260.7483,
    x2: 216.6797,
    y2: 355.9935,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165952721850058682790000002565372024273012911_)"
    },
    d: "M190.258,270.25 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 S190.177,269.785,190.258,270.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147902491025025106410000002390353018419268755_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.7594,
    y1: 258.1652,
    x2: 221.801,
    y2: 353.4104,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147902491025025106410000002390353018419268755_)"
    },
    d: "M196.588,269.156 c0.081,0.466-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C196.065,268.378,196.508,268.69,196.588,269.156z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103259049853552054670000006927280361938443932_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.8806,
    y1: 255.5818,
    x2: 226.9227,
    y2: 350.8281,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103259049853552054670000006927280361938443932_)"
    },
    d: "M202.919,268.061 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C202.396,267.284,202.838,267.596,202.919,268.061z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145051372228721064200000002430282976633513123_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.002,
    y1: 252.9987,
    x2: 232.044,
    y2: 348.2448,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145051372228721064200000002430282976633513123_)"
    },
    d: "M209.249,266.967 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C208.726,266.189,209.169,266.501,209.249,266.967z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013892223729450897520000014601164462675646356_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.1234,
    y1: 250.4158,
    x2: 237.1653,
    y2: 345.6618,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013892223729450897520000014601164462675646356_)"
    },
    d: "M215.58,265.872 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C215.057,265.094,215.499,265.406,215.58,265.872z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054986800493958755630000002001296179964476318_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.245,
    y1: 247.8332,
    x2: 242.2863,
    y2: 343.078,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054986800493958755630000002001296179964476318_)"
    },
    d: "M221.91,264.777 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C221.387,264,221.83,264.312,221.91,264.777z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130631357185142482060000015982594081494041747_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.5737,
    y1: 261.7879,
    x2: 214.617,
    y2: 357.0367,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130631357185142482060000015982594081494041747_)"
    },
    d: "M191.132,275.308 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C190.609,274.53,191.052,274.842,191.132,275.308z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112628473830658188290000003413994366235861169_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.695,
    y1: 259.2049,
    x2: 219.7384,
    y2: 354.4537,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112628473830658188290000003413994366235861169_)"
    },
    d: "M197.463,274.213 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C196.94,273.436,197.382,273.748,197.463,274.213z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102514777291447413830000006742232068160684432_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.8166,
    y1: 256.6223,
    x2: 224.8592,
    y2: 351.8696,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102514777291447413830000006742232068160684432_)"
    },
    d: "M203.793,273.119 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 S203.713,272.653,203.793,273.119z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000909692715389272620000004656348944662431398_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.9377,
    y1: 254.0388,
    x2: 229.9807,
    y2: 349.2868,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000909692715389272620000004656348944662431398_)"
    },
    d: "M210.124,272.024 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C209.601,271.246,210.043,271.559,210.124,272.024z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142893661164493097260000000012018575693533363_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.0591,
    y1: 251.4558,
    x2: 235.102,
    y2: 346.7038,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142893661164493097260000000012018575693533363_)"
    },
    d: "M216.454,270.93 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 C215.931,270.152,216.374,270.464,216.454,270.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069387119008063297420000012614479710574788789_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.1804,
    y1: 248.8726,
    x2: 240.2233,
    y2: 344.1206,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069387119008063297420000012614479710574788789_)"
    },
    d: "M222.785,269.835 c0.081,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C222.262,269.057,222.704,269.369,222.785,269.835z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077302502842057480410000003124538634086051463_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.5101,
    y1: 262.8293,
    x2: 212.5527,
    y2: 358.0768,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077302502842057480410000003124538634086051463_)"
    },
    d: "M192.007,280.365 c0.08,0.466-0.232,0.908-0.697,0.989c-0.466,0.081-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 C191.484,279.588,191.926,279.9,192.007,280.365z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129170779745261120640000000706857540305312664_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.6313,
    y1: 260.2461,
    x2: 217.6742,
    y2: 355.4941,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129170779745261120640000000706857540305312664_)"
    },
    d: "M198.337,279.271 c0.081,0.465-0.232,0.908-0.697,0.989s-0.908-0.232-0.989-0.697c-0.081-0.465,0.232-0.908,0.697-0.989 S198.257,278.805,198.337,279.271z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042014222365722859020000007953693798179505027_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.7526,
    y1: 257.6629,
    x2: 222.7955,
    y2: 352.9109,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042014222365722859020000007953693798179505027_)"
    },
    d: "M204.668,278.176 c0.08,0.465-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.466,0.232-0.908,0.697-0.989 S204.587,277.711,204.668,278.176z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106832419918107598090000015909474005343303853_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.8739,
    y1: 255.0798,
    x2: 227.9169,
    y2: 350.3279,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106832419918107598090000015909474005343303853_)"
    },
    d: "M210.998,277.082 c0.081,0.465-0.232,0.908-0.697,0.989c-0.465,0.08-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 S210.918,276.616,210.998,277.082z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054244844256623083380000001362890657959527864_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.995,
    y1: 252.4963,
    x2: 233.0384,
    y2: 347.745,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054244844256623083380000001362890657959527864_)"
    },
    d: "M217.329,275.987 c0.08,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.081-0.466,0.232-0.908,0.697-0.989 C216.806,275.209,217.248,275.522,217.329,275.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060004366107050994140000013994723180633270206_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.1164,
    y1: 249.9132,
    x2: 238.1597,
    y2: 345.162,
    gradientTransform: "matrix(0.9854 -0.1704 0.1704 0.9854 -42.3152 13.7254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060004366107050994140000013994723180633270206_)"
    },
    d: "M223.659,274.892 c0.081,0.466-0.232,0.908-0.697,0.989c-0.465,0.081-0.908-0.232-0.989-0.697c-0.08-0.465,0.232-0.908,0.697-0.989 C223.136,274.115,223.579,274.427,223.659,274.892z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179636275622781155880000005541157002765868955_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.7472,
    y1: 296.9674,
    x2: 204.9408,
    y2: 173.7896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22224C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E3E72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179636275622781155880000005541157002765868955_)"
    },
    d: "M269.963,200.247l-68.36,26.131 l-22.693,8.675c-1.117,0.429-2.368-0.129-2.798-1.246l-21.153-55.342c-0.429-1.117,0.135-2.369,1.252-2.798l91.053-34.806 c1.117-0.423,2.369,0.135,2.798,1.252l2.445,6.389l18.708,48.947C271.644,198.572,271.079,199.824,269.963,200.247z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000187368578404548950000007262983228336545164_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.5326,
    y1: 272.7344,
    x2: 190.5784,
    y2: 123.1565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5666E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52CDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000187368578404548950000007262983228336545164_)"
    },
    d: "M264.53,199.076l-82.355,31.48 c-1.011,0.387-2.144-0.12-2.531-1.131l-19.132-50.051c-0.387-1.011,0.12-2.144,1.131-2.531l82.355-31.48 c1.011-0.387,2.144,0.12,2.531,1.131l19.132,50.051C266.048,197.556,265.541,198.689,264.53,199.076z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092425316839445159870000013408648317368809660_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.4683,
    y1: 294.6903,
    x2: 202.9951,
    y2: 174.8603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092425316839445159870000013408648317368809660_)"
    },
    d: "M204.532,202.035l1.665-12.34 c0.159-1.177,1.435-1.841,2.49-1.296l4.094,2.115c1.043,0.539,2.306-0.104,2.486-1.264l1.507-9.754 c0.212-1.371,1.878-1.938,2.882-0.981l13.512,12.879c0.918,0.875,0.604,2.408-0.583,2.852l-25.75,9.627 C205.619,204.328,204.358,203.321,204.532,202.035z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126318271449935588820000014593288675909759410_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.1487,
    y1: 284.2202,
    x2: 217.6747,
    y2: 164.3892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126318271449935588820000014593288675909759410_)"
    },
    d: "M226.197,173.768 c0,1.012-0.821,1.833-1.833,1.833c-1.012,0-1.833-0.821-1.833-1.833c0-1.012,0.821-1.833,1.833-1.833 C225.377,171.935,226.197,172.755,226.197,173.768z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152229588357227006680000008185525026041561233_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.9918,
    y1: 184.3109,
    x2: 198.2734,
    y2: 188.7102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000152229588357227006680000008185525026041561233_)"
    },
    d: "M269.963,200.247 l-68.36,26.131c3.938-7.729,15.364-9.627,17.509-18.32c2.598-10.538,14.576-5.801,15.416-20.101 c0.835-14.3,12.566-8.746,11.937-25.626c-0.329-8.893,2.904-12.449,6.042-13.83l18.708,48.947 C271.644,198.572,271.079,199.824,269.963,200.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072257579721888703080000013650331617396847781_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.8444,
    y1: 232.6987,
    x2: 311.0064,
    y2: 144.5022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5666E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52CDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072257579721888703080000013650331617396847781_)"
    },
    d: "M311.361,149.764 c0,0-4.162-2.632-7.504,4.716c-3.342,7.347-3.297,28.716-2.691,33.953c0.606,5.237,2.163,47.038,2.163,47.038 s13.387,2.835,17.018,0c3.631-2.835,0.661-74.903,0-76.786c-0.661-1.883-2.288-12.12-2.288-12.12L311.361,149.764z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057147146144350774410000011715906440567555995_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.0411,
    y1: 142.314,
    x2: 308.2981,
    y2: 152.3697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057147146144350774410000011715906440567555995_)"
    },
    d: "M303.857,154.48 c0,0,4.297-3.571,8.848-4.484l-1.344-4.718c0,0-1.655-0.644-4.13,0.228c-2.474,0.872-3.374,6.319-3.374,6.319V154.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07071C"
    },
    d: "M327.861,132.216c-2.445,3.003-3.562,7.123-4.543,6.636c-0.976-0.488-3.139-6.212-3.139-6.212 s4.05-0.911,2.721-3.914c-1.328-2.997-4.05-0.694-4.05-0.694s0.558-3.074-0.347-3.285c-0.717-0.159-9.956,1.005-17.339-0.711 c-2.022-0.476-3.903-1.164-5.431-2.151c-3.356-2.175-4.714-4.913-4.772-7.517c-0.076-2.921,1.475-5.666,3.656-7.217 c4.079-2.903,15.893-0.4,16.128-0.353c-0.135-0.223-3.344-5.531,0.006-6.418c3.421-0.911,8.94,8.728,13.894,12.29 c3.591,2.58,5.055,5.56,4.479,8.387c-0.217,1.076-0.735,2.128-1.546,3.133C331.423,126.145,330.306,129.219,327.861,132.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168105476646804146700000004403764850313309075_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.1787,
    y1: 102.2545,
    x2: 309.8661,
    y2: 138.9857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168105476646804146700000004403764850313309075_)"
    },
    d: "M323.318,138.852 c-0.47,0.97-1.146,1.804-1.957,2.51c-1.446,1.264-3.338,2.122-5.302,2.627c-1.363,0.347-2.757,0.529-4.067,0.558 c-0.741,0.018-1.452-0.012-2.116-0.088c-0.711-0.076-1.364-0.206-1.934-0.388c-8.299-2.592-9.098-9.445-8.287-14.629 c0.159-1.058,0.394-2.045,0.641-2.909c0.294-1.029,0.611-1.887,0.87-2.498c7.382,1.716,16.621,0.552,17.339,0.711 c0.905,0.212,0.347,3.285,0.347,3.285s2.721-2.304,4.05,0.694c1.328,3.003-2.721,3.914-2.721,3.914 S322.342,138.364,323.318,138.852z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    x1: 301.166,
    y1: 124.035,
    x2: 301.166,
    y2: 124.029
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116953771487050698760000003136968303918552741_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.815,
    y1: 132.8457,
    x2: 314.4863,
    y2: 151.9757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116953771487050698760000003136968303918552741_)"
    },
    d: "M321.819,147.215 c0,1.205-1.305,3.591-2.98,5.407c-0.094,0.1-0.194,0.2-0.288,0.3c-0.729,0.746-1.516,1.363-2.286,1.728 c-0.87,0.411-1.804,0.523-2.674,0.417c-1.798-0.206-3.362-1.293-3.714-2.457c-0.453-1.481,0.141-4.343,0.088-6.9 c-0.006-0.429-0.035-0.846-0.088-1.252c3.538,0.406,8.469-0.464,11.484-3.097c-0.047,0.552-0.023,1.181,0.041,1.828 C321.531,144.629,321.819,146.169,321.819,147.215z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075878446084276356480000013563999184798329738_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.5335,
    y1: 138.8181,
    x2: 309.7796,
    y2: 156.2059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000075878446084276356480000013563999184798329738_)"
    },
    d: "M321.819,147.215 c0,1.205-1.305,3.591-2.98,5.407c-0.529-0.082-1.064-0.223-1.599-0.435c-5.895-2.327-2.269-5.372-5.76-6.071 c-0.605-0.117-1.105-0.259-1.516-0.406c-0.006-0.429-0.035-0.846-0.088-1.252c3.538,0.406,8.469-0.464,11.484-3.097 c-0.047,0.552-0.023,1.181,0.041,1.828C321.531,144.629,321.819,146.169,321.819,147.215z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088852972024685434410000008023040092791167652_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.4506,
    y1: 141.1207,
    x2: 325.6405,
    y2: 190.1421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088852972024685434410000008023040092791167652_)"
    },
    d: "M319.686,156.801 c0.1-2.833-3.144-6.289-2.304-9.01c0.835-2.721,4.267-2.521,4.014-4.602c0,0,4.772,1.793,5.501,5.043 c0.018,0.07,0.029,0.135,0.041,0.206C327.473,151.6,323.782,154.339,319.686,156.801z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171722128092994083450000007226589614246815919_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.7686,
    y1: 244.917,
    x2: 293.5787,
    y2: 163.6338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171722128092994083450000007226589614246815919_)"
    },
    d: "M307.231,145.505 c-0.059,0.047-0.117,0.094-0.17,0.141c-0.076,0.065-0.147,0.165-0.217,0.294c-0.023,0.041-0.047,0.088-0.07,0.135 c-0.035,0.07-0.07,0.141-0.1,0.223c-0.417,1.011-0.805,2.968-1.146,5.454v0.018c-0.958,7.029-1.528,18.267-1.24,24.374 c0.182,3.891,0.2,15.552,0.047,27.712c-0.082,6.724-0.212,13.6-0.394,19.401c-0.165,5.254-0.364,9.633-0.611,12.213 c-0.117,1.27-0.247,2.104-0.388,2.404c-0.976,2.075-6.007,1.757-8.928,0.482c-1.011-0.435-1.763-0.987-2.016-1.599 c-0.4-0.976,0.276-6.688,1.123-14.264c0.541-4.867,1.152-10.509,1.587-16.157c0.541-7,0.817-14.012,0.358-19.578 c-5.519,5.254-7.57,5.924-10.356,5.237c-0.176-0.047-0.353-0.094-0.535-0.147c-1.246-0.364-2.357-3.133-3.168-6.465 c-1.017-4.155-1.569-9.192-1.346-11.508c0.035-0.406,0.094-0.729,0.182-0.946c0.135-0.347,0.323-0.611,0.558-0.829 c1.458-1.37,4.708-0.705,7.964-4.197c0.893-0.952,2.245-2.804,3.885-5.072c2.374-3.297,5.342-7.464,8.334-10.997 c2.18-2.574,4.367-4.808,6.342-6.13c0.006-0.006,0.012-0.006,0.018-0.006C307.043,145.628,307.137,145.564,307.231,145.505z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016784532788005969170000004568871879789534871_",
    d: "M307.231,145.505 c-0.059,0.047-0.117,0.094-0.17,0.141c-0.076,0.065-0.147,0.165-0.217,0.294c-0.023,0.041-0.047,0.088-0.07,0.135 c-0.035,0.07-0.07,0.141-0.1,0.223c-0.417,1.011-0.805,2.968-1.146,5.454v0.018c-0.958,7.029-1.528,18.267-1.24,24.374 c0.182,3.891,0.2,15.552,0.047,27.712c-0.082,6.724-0.212,13.6-0.394,19.401c-0.165,5.254-0.364,9.633-0.611,12.213 c-0.117,1.27-0.247,2.104-0.388,2.404c-0.976,2.075-6.007,1.757-8.928,0.482c-1.011-0.435-1.763-0.987-2.016-1.599 c-0.4-0.976,0.276-6.688,1.123-14.264c0.541-4.867,1.152-10.509,1.587-16.157c0.541-7,0.817-14.012,0.358-19.578 c-5.519,5.254-7.57,5.924-10.356,5.237c-0.176-0.047-0.353-0.094-0.535-0.147c-1.246-0.364-2.357-3.133-3.168-6.465 c-1.017-4.155-1.569-9.192-1.346-11.508c0.035-0.406,0.094-0.729,0.182-0.946c0.135-0.347,0.323-0.611,0.558-0.829 c1.458-1.37,4.708-0.705,7.964-4.197c0.893-0.952,2.245-2.804,3.885-5.072c2.374-3.297,5.342-7.464,8.334-10.997 c2.18-2.574,4.367-4.808,6.342-6.13c0.006-0.006,0.012-0.006,0.018-0.006C307.043,145.628,307.137,145.564,307.231,145.505z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080912118083571022740000017238853465469674117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016784532788005969170000004568871879789534871_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080912118083571022740000017238853465469674117_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C275.322,185.155,275.705,185.538,275.705,186.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C281.747,185.155,282.13,185.538,282.13,186.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.554,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C288.171,185.155,288.554,185.538,288.554,186.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C294.596,185.155,294.979,185.538,294.979,186.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.403,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C301.02,185.155,301.403,185.538,301.403,186.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,186.01c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C307.445,185.155,307.828,185.538,307.828,186.01z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,191.143c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C275.322,190.287,275.705,190.67,275.705,191.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,191.143c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C281.747,190.287,282.13,190.67,282.13,191.143z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.699,
    cy: 191.143,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,191.143c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C294.596,190.287,294.979,190.67,294.979,191.143z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.548,
    cy: 191.143,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,191.143c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C307.445,190.287,307.828,190.67,307.828,191.143z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.856,0.855-0.856C275.322,195.42,275.705,195.803,275.705,196.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.473,0.383-0.856,0.855-0.856 C281.747,195.42,282.13,195.803,282.13,196.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.554,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.856,0.855-0.856C288.171,195.42,288.554,195.803,288.554,196.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.856,0.855-0.856C294.596,195.42,294.979,195.803,294.979,196.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.403,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.856,0.855-0.856C301.02,195.42,301.403,195.803,301.403,196.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,196.275c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.856,0.855-0.856C307.445,195.42,307.828,195.803,307.828,196.275z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C275.322,200.552,275.705,200.935,275.705,201.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C281.747,200.552,282.13,200.935,282.13,201.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.554,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C288.171,200.552,288.554,200.935,288.554,201.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C294.596,200.552,294.979,200.935,294.979,201.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.403,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C301.02,200.552,301.403,200.935,301.403,201.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,201.408c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C307.445,200.552,307.828,200.935,307.828,201.408z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C275.322,205.685,275.705,206.068,275.705,206.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C281.747,205.685,282.13,206.068,282.13,206.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.554,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C288.171,205.685,288.554,206.068,288.554,206.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C294.596,205.685,294.979,206.068,294.979,206.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.403,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C301.02,205.685,301.403,206.068,301.403,206.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,206.54c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C307.445,205.685,307.828,206.068,307.828,206.54z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,211.673c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C275.322,210.818,275.705,211.201,275.705,211.673z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,211.673c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C281.747,210.818,282.13,211.201,282.13,211.673z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.699,
    cy: 211.673,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,211.673c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C294.596,210.818,294.979,211.201,294.979,211.673z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.548,
    cy: 211.673,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,211.673c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C307.445,210.818,307.828,211.201,307.828,211.673z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.705,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C275.322,215.95,275.705,216.333,275.705,216.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.473,0.383-0.855,0.855-0.855 C281.747,215.95,282.13,216.333,282.13,216.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.554,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C288.171,215.95,288.554,216.333,288.554,216.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.979,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C294.596,215.95,294.979,216.333,294.979,216.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.403,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C301.02,215.95,301.403,216.333,301.403,216.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.828,216.805c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C307.445,215.95,307.828,216.333,307.828,216.805z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080912118083571022740000017238853465469674117_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 268.648,
    cy: 141.404,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,141.404c0,0.472-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C275.545,140.548,275.928,140.931,275.928,141.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,141.404c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.473,0.383-0.855,0.856-0.855C281.969,140.548,282.352,140.931,282.352,141.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,141.404c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C288.394,140.548,288.777,140.931,288.777,141.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,141.404c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C294.818,140.548,295.201,140.931,295.201,141.404z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.77,
    cy: 141.404,
    r: 0.855
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.503,146.536c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C269.12,145.681,269.503,146.064,269.503,146.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,146.536c0,0.472-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C275.545,145.681,275.928,146.064,275.928,146.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,146.536c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.473,0.383-0.855,0.856-0.855C281.969,145.681,282.352,146.064,282.352,146.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,146.536c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C288.394,145.681,288.777,146.064,288.777,146.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,146.536c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C294.818,145.681,295.201,146.064,295.201,146.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.626,146.536c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C301.243,145.681,301.626,146.064,301.626,146.536z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.503,151.669c0,0.473-0.383,0.856-0.855,0.856c-0.473,0-0.855-0.383-0.855-0.856 c0-0.472,0.383-0.855,0.855-0.855C269.12,150.813,269.503,151.196,269.503,151.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,151.669c0,0.473-0.383,0.856-0.856,0.856c-0.472,0-0.855-0.383-0.855-0.856 c0-0.472,0.383-0.855,0.855-0.855C275.545,150.813,275.928,151.196,275.928,151.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,151.669c0,0.473-0.383,0.856-0.855,0.856c-0.473,0-0.856-0.383-0.856-0.856 c0-0.472,0.383-0.855,0.856-0.855C281.969,150.813,282.352,151.196,282.352,151.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,151.669c0,0.473-0.383,0.856-0.855,0.856c-0.472,0-0.855-0.383-0.855-0.856 c0-0.472,0.383-0.855,0.855-0.855C288.394,150.813,288.777,151.196,288.777,151.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,151.669c0,0.473-0.383,0.856-0.855,0.856c-0.473,0-0.855-0.383-0.855-0.856 c0-0.472,0.383-0.855,0.855-0.855C294.818,150.813,295.201,151.196,295.201,151.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.626,151.669c0,0.473-0.383,0.856-0.855,0.856c-0.472,0-0.855-0.383-0.855-0.856 c0-0.472,0.383-0.855,0.855-0.855C301.243,150.813,301.626,151.196,301.626,151.669z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 268.648,
    cy: 156.801,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,156.801c0,0.472-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C275.545,155.946,275.928,156.329,275.928,156.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,156.801c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.472,0.383-0.855,0.856-0.855C281.969,155.946,282.352,156.329,282.352,156.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,156.801c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C288.394,155.946,288.777,156.329,288.777,156.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,156.801c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C294.818,155.946,295.201,156.329,295.201,156.801z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.77,
    cy: 156.801,
    r: 0.855
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.503,161.934c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C269.12,161.079,269.503,161.462,269.503,161.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,161.934c0,0.472-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C275.545,161.079,275.928,161.462,275.928,161.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,161.934c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.473,0.383-0.855,0.856-0.855C281.969,161.079,282.352,161.462,282.352,161.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,161.934c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C288.394,161.079,288.777,161.462,288.777,161.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,161.934c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C294.818,161.079,295.201,161.462,295.201,161.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.626,161.934c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C301.243,161.079,301.626,161.462,301.626,161.934z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.503,167.066c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C269.12,166.211,269.503,166.594,269.503,167.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,167.066c0,0.473-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C275.545,166.211,275.928,166.594,275.928,167.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,167.066c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.472,0.383-0.855,0.856-0.855C281.969,166.211,282.352,166.594,282.352,167.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,167.066c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C288.394,166.211,288.777,166.594,288.777,167.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,167.066c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C294.818,166.211,295.201,166.594,295.201,167.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.626,167.066c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C301.243,166.211,301.626,166.594,301.626,167.066z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M269.503,172.199c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C269.12,171.344,269.503,171.727,269.503,172.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.928,172.199c0,0.473-0.383,0.855-0.856,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C275.545,171.344,275.928,171.727,275.928,172.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352,172.199c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.856-0.383-0.856-0.855 c0-0.472,0.383-0.855,0.856-0.855C281.969,171.344,282.352,171.727,282.352,172.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.777,172.199c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C288.394,171.344,288.777,171.727,288.777,172.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.201,172.199c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C294.818,171.344,295.201,171.727,295.201,172.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.626,172.199c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C301.243,171.344,301.626,171.727,301.626,172.199z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034062429482106453090000012197208308479152262_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.7014,
    y1: 243.0648,
    x2: 329.5115,
    y2: 161.7816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034062429482106453090000012197208308479152262_)"
    },
    d: "M347.997,233.96 c-0.611,1.128-2.245,2.357-4.449,3.509c-7.329,3.832-20.959,6.83-24.18,2.639c-0.523-0.676-1.023-2.186-1.505-4.338 c-3.391-15.152-5.666-62.13-5.061-73.874c0.147-2.792,0.429-5.031,0.788-6.829c1.358-6.835,3.791-7.276,3.791-7.276 c-0.482,1.557,0.37,3.35,1.17,5.131c0.605,1.334,1.176,2.662,1.134,3.879c4.097-2.463,7.788-5.202,7.253-8.364 c2.839,0.87,12.213,5.061,16.733,12.061c1.052,1.628,1.922,3.591,2.592,5.795c2.927,9.627,1.945,23.81-4.966,34.653 c-0.047,0.071-0.094,0.141-0.141,0.212c-0.264,0.417-0.547,0.835-0.835,1.24C339.757,212.173,350.654,229.076,347.997,233.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142856798725016505740000010151485212554284987_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.9934,
    y1: 174.241,
    x2: 258.5083,
    y2: 165.8612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142856798725016505740000010151485212554284987_)"
    },
    d: "M284.709,191.995 c-7.47,1.622-16.098-2.439-17.82-4.925c-0.405-0.588-1.375-2.815-2.639-5.942c-4.549-11.285-12.966-34.277-12.966-34.277 s-5.971-5.137-2.721-5.49c2.451-0.265,7.887,3.832,11.62,9.104c1.211,1.71,2.245,3.544,2.939,5.39 c2.827,7.541,8.481,16.239,17.28,16.245c-0.235,0.217-0.423,0.482-0.558,0.829c-0.088,0.218-0.147,0.541-0.182,0.946 c-0.223,2.316,0.329,7.353,1.346,11.508c0.811,3.332,1.922,6.101,3.168,6.465C284.357,191.901,284.533,191.949,284.709,191.995z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049929698192901495330000015498163113536240266_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.2386,
    y1: 229.0718,
    x2: 315.3334,
    y2: 358.9573
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22224C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E3E72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049929698192901495330000015498163113536240266_)"
    },
    d: "M355.262,366.085 c-1.34,2.192-3.474,3.985-5.936,5.39c-5.002,2.856-11.373,4.091-15.299,3.697c-1.775-0.176-3.05-0.682-3.468-1.522 c-1.798-3.603-14.4-92.758-14.4-92.758s-18.155,89.937-19.836,91.335c-0.147,0.117-0.406,0.247-0.77,0.376 c-0.523,0.188-1.258,0.376-2.134,0.541c-3.621,0.676-9.715,0.94-13.835-0.964c-2.145-0.987-3.756-2.568-4.208-4.978 c-1.61-8.587,15.323-108.098,18.637-128.845c1.258,0.552,2.909,0.923,4.461,0.999c2.045,0.106,3.914-0.3,4.467-1.481 c0.141-0.3,0.27-1.134,0.388-2.404c2.886,0.799,7.829,1.54,14.535,0.3c0.482,2.151,0.982,3.662,1.505,4.338 c3.221,4.191,16.851,1.193,24.18-2.639c1.211,16.063,5.443,50.969,8.534,80.544C354.51,341.2,356.238,361.107,355.262,366.085z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032629363160678295890000005492028592876861618_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.87,
    y1: 390.1758,
    x2: 298.9443,
    y2: 390.1758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22224C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E3E72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032629363160678295890000005492028592876861618_)"
    },
    d: "M298.944,403.477 c0,0-49.229,1.887-52.162,0c-2.933-1.887-2.933-10.368,3.139-12.36c6.077-1.992,21.265-7.123,29.017-15.081 c0,0,0.035,0.065,0.106,0.176c0.47,0.788,2.627,3.961,7.018,5.06c5.025,1.258,6.806-1.152,7.752-0.423 C294.754,381.584,298.944,403.477,298.944,403.477z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137849277977009454910000014664350743488023479_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.2652,
    y1: 390.8548,
    x2: 364.7033,
    y2: 390.8548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22224C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E3E72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137849277977009454910000014664350743488023479_)"
    },
    d: "M364.343,403.477h-34.077 c0,0,4.467-19.66,5.025-20.777c0.065-0.135,0.176-0.229,0.317-0.282c1.005-0.429,3.709,0.899,5.548,0.282 c2.098-0.699,3.491-4.326,6.565-4.467c0.676-0.029,1.317,0.341,1.916,0.97c2.128,2.21,3.791,7.635,5.208,9.921 C356.661,392.058,366.717,395.343,364.343,403.477z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110433093836244309630000000946988452259937683_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.8103,
    y1: 366.129,
    x2: 286.9723,
    y2: 379.6761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110433093836244309630000000946988452259937683_)"
    },
    d: "M295.553,372.603l-1.74,8.246 c-0.946-0.729-2.727,1.681-7.752,0.423c-4.39-1.099-6.548-4.273-7.018-5.06l0.541-4.032 C284.703,374.543,292.861,373.567,295.553,372.603z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013191209879651895200000006544883037919192960_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.3075,
    y1: 369.4999,
    x2: 341.4695,
    y2: 383.0471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013191209879651895200000006544883037919192960_)"
    },
    d: "M349.637,379.204 c-0.599-0.629-1.24-0.999-1.916-0.97c-3.074,0.141-4.467,3.768-6.565,4.467c-1.84,0.617-4.543-0.711-5.548-0.282 c-0.388-2.78-1.087-5.519-1.581-7.247c3.926,0.394,10.297-0.84,15.299-3.697C349.349,374.249,349.508,377.199,349.637,379.204z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157987990974869553040000007472310018736114340_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.4012,
    y1: 187.6372,
    x2: 277.8496,
    y2: 212.7764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF7E64"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC8B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157987990974869553040000007472310018736114340_)"
    },
    d: "M335.502,206.865 c-10.374,16.239-31.95,18.855-46.508,14.664c-6.536-1.881-10.703-4.032-13.318-5.836c0,0-0.006,0-0.012-0.006 c-3.203-2.216-4.061-3.897-4.061-3.897s-12.043,0.317-15.499-6.389c-5.76-1.152-5.554-3.667-5.131-4.191 c0.417-0.523,14.558,0,19.478-2.092c-2.51-3.25-0.523-6.494,1.364-6.289c1.887,0.212,2.827,7.541,4.714,9.951 c1.887,2.41,10.685,4.925,21.37,3.144c4.355-0.723,8.81-3.039,12.566-5.519c5.46-3.603,9.427-7.576,9.427-7.576 s0.359,0.746,1.035,1.893c1.328,2.263,3.879,6.077,7.353,8.846C330.377,205.249,332.804,206.536,335.502,206.865z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018950745596012011390000001422966758719315098_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.2348,
    y1: 142.763,
    x2: 306.4246,
    y2: 191.7845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018950745596012011390000001422966758719315098_)"
    },
    d: "M307.061,145.646 c-0.076,0.065-0.147,0.165-0.217,0.294c-0.029,0.041-0.053,0.088-0.07,0.135c-0.035,0.07-0.07,0.141-0.1,0.223 c-0.458,1.193-0.694,3.485-1.146,5.454v0.018c-0.029,0.123-0.059,0.247-0.088,0.37c-0.629,2.51-5.554,5.443-6.389,4.661 c-0.817-0.764,0.682-1.716,1.534-4.966c0.035-0.106,0.065-0.212,0.088-0.323c0.764-3.18,5.39-5.413,6.254-5.807 c0.006-0.006,0.012-0.006,0.018-0.006C307.02,145.664,307.061,145.646,307.061,145.646z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080179088275237548150000017960803613457915796_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.4522,
    y1: 260.9658,
    x2: 280.0177,
    y2: 181.6378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000080179088275237548150000017960803613457915796_)"
    },
    d: "M335.502,206.865 c-10.374,16.239-31.95,18.855-46.508,14.664c-6.536-1.881-10.703-4.032-13.318-5.836c3.485,1.369,9.451,3.268,14.505,2.627 c7.676-0.97,10.891,1.117,20.113-3.35c9.216-4.473,9.492-2.098,12.983-6.906c1.581-2.169,3.438-3.591,5.002-4.496 C330.377,205.249,332.804,206.536,335.502,206.865z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060029700423097268580000008249528314870050698_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.5602,
    y1: 195.575,
    x2: 310.2623,
    y2: 170.4359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000060029700423097268580000008249528314870050698_)"
    },
    d: "M341.297,200.947 c-0.047,0.071-0.094,0.141-0.141,0.212c-1.628,2.416-3.521,4.396-5.654,5.707c-2.698-0.329-5.125-1.616-7.223-3.297 c5.548-1.728,5.196-10.873,7.782-13.113c2.58-2.233,5.307-6.63,4.884-10.474c-0.3-2.78,3.973-9.075,5.319-13.689 C349.191,175.921,348.209,190.103,341.297,200.947z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108287595444030191320000016640015603835298238_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.2073,
    y1: 194.9655,
    x2: 320.2073,
    y2: 194.9655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9C6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DCE9FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108287595444030191320000016640015603835298238_)"
    },
    d: "M320.207,194.965"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170963357435446709120000009209351044627462037_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.3067,
    y1: 184.4627,
    x2: 337.4068,
    y2: 221.4733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000170963357435446709120000009209351044627462037_)"
    },
    d: "M320.926,194.723 c-1.428,1.087-3.027,2.304-5.166,3.556c-1.987,1.164-3.832,1.793-5.296,2.128c5.46-3.603,9.427-7.576,9.427-7.576 S320.25,193.577,320.926,194.723z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047024139389933576470000013880232482461161610_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.2897,
    y1: 173.7461,
    x2: 349.3895,
    y2: 210.7564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000047024139389933576470000013880232482461161610_)"
    },
    d: "M319.891,192.83 c4.82-3.14,9.01-20.214,9.324-20.424c1.345,2.304,0.21,3.666,0,5.761c-0.209,2.095,1.362,3.038-0.419,5.656 c-1.781,2.619-2.619,1.781-3.247,5.133c-0.628,3.352-3.177,4.679-4.623,5.766"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021103813271425822320000009694027648533133205_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.3566,
    y1: 212.4901,
    x2: 266.9382,
    y2: 138.4696
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000021103813271425822320000009694027648533133205_)"
    },
    d: "M295.065,186.759 c-5.519,5.254-7.57,5.924-10.356,5.237c-7.47,1.622-16.098-2.439-17.82-4.925c-0.405-0.588-1.375-2.815-2.639-5.942 c4.72,1.522,7.829,7.617,11.426,6.048c2.31-1.011,3.456-1.311,5.331-1.793c1.428-0.37,3.291-0.846,6.418-1.816 c7.223-2.251,2.304-9.38,7.641-13.677C294.436,171.883,294.859,186.335,295.065,186.759z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127747569312712787390000003078117687427344261_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.7485,
    y1: 323.6263,
    x2: 246.0353,
    y2: 308.5428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000127747569312712787390000003078117687427344261_)"
    },
    d: "M316.159,280.892 c0,0-18.155,89.937-19.836,91.335c-0.147,0.117-0.406,0.247-0.77,0.376c-0.523,0.188-1.258,0.376-2.134,0.541 c7.153-9.98-3.238-24.098,5.395-36.952c8.634-12.848-2.768-24.021,4.12-32.961c6.894-8.934,7.077-44.968,8.428-44.968 C312.709,258.264,316.159,280.892,316.159,280.892z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109005287446130716570000002365645321142308022_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.6917,
    y1: 239.2367,
    x2: 313.3579,
    y2: 288.3976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000109005287446130716570000002365645321142308022_)"
    },
    d: "M352.082,318.014 c-1.798-4.379-3.568-8.417-4.596-12.654c-2.192-9.051-0.047-14.417-3.115-21.676c-3.074-7.264-3.632-10.897-4.749-21.511 c-1.117-10.615-3.356-13.124-19.731-14.523c-10.403-0.887-17.55-5.043-21.417-8.293c2.045,0.106,3.914-0.3,4.467-1.481 c0.141-0.3,0.27-1.134,0.388-2.404c2.886,0.799,7.829,1.54,14.535,0.3c0.482,2.151,0.982,3.662,1.505,4.338 c3.221,4.191,16.851,1.193,24.18-2.639C344.759,253.532,348.991,288.438,352.082,318.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036236184086732116920000009810864225163147919_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.296,
    y1: 384.41,
    x2: 278.1799,
    y2: 384.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5666E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52CDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000036236184086732116920000009810864225163147919_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: " M260.572,385.496c0,0,2.601,7.053,5.106,7.193c2.505,0.14-2.523-7.263-1.056-9.288c1.466-2.025,3.561,6.707,6.774,6.775 c3.212,0.068-2.723-8.381-1.955-10.267c0.768-1.885,2.578,0.489,5.828,5.656c3.25,5.168,4.437-2.37-2.197-9.53"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183224030030604316840000007704685857506452413_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5733,
    y1: 390.7179,
    x2: 361.7327,
    y2: 390.7179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5666E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52CDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000183224030030604316840000007704685857506452413_)",
      strokeWidth: 0.5877,
      strokeMiterlimit: 10
    },
    d: " M354.355,384.867c0,0-9.218,0.489-10.405,3.492c-1.187,3.003,10.754-2.304,14.245,0.768c3.492,3.073-11.732,0.838-11.662,3.91 c0.07,3.073,13.435-2.911,14.804,0c1.369,2.911-11.592,1.746-12.5,3.701"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006707812577172167610000004436678033775869107_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.6393,
    y1: 146.1966,
    x2: 271.8782,
    y2: 188.5141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000006707812577172167610000004436678033775869107_)"
    },
    d: "M292.25,162.832 c-0.899,5.055-4.508,11.62-9.962,11.144c-0.958-0.082-1.834-0.112-2.627-0.1c-5.202,0.047-7.141,1.522-8.687-2.204 c-1.775-4.29-4.814-5.131-8.064-11.52c-1.981-3.909-2.569-7.488-2.727-9.686c1.211,1.71,2.245,3.544,2.939,5.39 c2.827,7.541,8.481,16.239,17.28,16.245c1.458-1.37,4.708-0.705,7.964-4.197C289.258,166.952,290.61,165.1,292.25,162.832z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057134288828176419460000004070632824208668034_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.0235,
    y1: 105.7067,
    x2: 299.971,
    y2: 147.6054
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000057134288828176419460000004070632824208668034_)"
    },
    d: "M323.318,138.852 c-0.47,0.97-1.146,1.804-1.957,2.51c-1.446,1.264-3.338,2.122-5.302,2.627c0.476-2.38,5.113-4.59,3.468-7.094 c-1.728-2.615-0.893-5.237-3.25-5.601c-2.357-0.364-4.343-0.576-7.118-3.144c-2.78-2.563-3.826-0.259-7.335-1.099 c-0.629-0.153-1.128-0.329-1.528-0.517c0.294-1.029,0.611-1.887,0.87-2.498c7.382,1.716,16.621,0.552,17.339,0.711 c0.905,0.212,0.347,3.285,0.347,3.285s2.721-2.304,4.05,0.694c1.328,3.003-2.721,3.914-2.721,3.914 S322.342,138.364,323.318,138.852z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134251838810269798490000015301081735202484632_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.7801,
    y1: 153.6729,
    x2: 322.7236,
    y2: 124.7628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_00000134251838810269798490000015301081735202484632_)"
    },
    d: "M311.992,144.547 c-0.741,0.018-1.452-0.012-2.116-0.088c-0.711-0.076-1.364-0.206-1.934-0.388c-8.299-2.592-9.098-9.445-8.287-14.629 c0.288,0.411,0.6,1.217,0.641,2.745c0.076,2.962,1.058,6.806,4.196,8.898C307.273,142.942,311.122,142.772,311.992,144.547z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000030467041943830975430000001596339732633076630_",
    d: "M347.997,233.96 c-0.611,1.128-2.245,2.357-4.449,3.509c-7.329,3.832-20.959,6.83-24.18,2.639c-0.523-0.676-1.023-2.186-1.505-4.338 c-3.391-15.152-5.666-62.13-5.061-73.874c0.147-2.792,0.429-5.031,0.788-6.829c1.358-6.835,3.791-7.276,3.791-7.276 c-0.482,1.557,0.37,3.35,1.17,5.131c0.605,1.334,1.176,2.662,1.134,3.879c4.097-2.463,7.788-5.202,7.253-8.364 c2.839,0.87,12.213,5.061,16.733,12.061c1.052,1.628,1.922,3.591,2.592,5.795c2.927,9.627,1.945,23.81-4.966,34.653 c-0.047,0.071-0.094,0.141-0.141,0.212c-0.264,0.417-0.547,0.835-0.835,1.24C339.757,212.173,350.654,229.076,347.997,233.96z "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097494184234427817960000007998634979800497587_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000030467041943830975430000001596339732633076630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097494184234427817960000007998634979800497587_)"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.573,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C331.19,137.848,331.573,138.23,331.573,138.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C337.615,137.848,337.998,138.23,337.998,138.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C344.039,137.848,344.422,138.23,344.422,138.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C350.464,137.848,350.847,138.23,350.847,138.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C356.888,137.848,357.271,138.23,357.271,138.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.696,138.703c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C363.313,137.848,363.696,138.23,363.696,138.703z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.573,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C331.19,142.98,331.573,143.363,331.573,143.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C337.615,142.98,337.998,143.363,337.998,143.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C344.039,142.98,344.422,143.363,344.422,143.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C350.464,142.98,350.847,143.363,350.847,143.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C356.888,142.98,357.271,143.363,357.271,143.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.696,143.835c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C363.313,142.98,363.696,143.363,363.696,143.835z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 330.718,
    cy: 148.968,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,148.968c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C337.615,148.113,337.998,148.496,337.998,148.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,148.968c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C344.039,148.113,344.422,148.496,344.422,148.968z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.991,
    cy: 148.968,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,148.968c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C356.888,148.113,357.271,148.496,357.271,148.968z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.84,
    cy: 148.968,
    r: 0.855
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 330.718,
    cy: 154.101,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,154.101c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C337.615,153.245,337.998,153.628,337.998,154.101z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,154.101c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C344.039,153.245,344.422,153.628,344.422,154.101z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.991,
    cy: 154.101,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,154.101c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C356.888,153.245,357.271,153.628,357.271,154.101z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.84,
    cy: 154.101,
    r: 0.855
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.573,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C331.19,158.378,331.573,158.761,331.573,159.233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C337.615,158.378,337.998,158.761,337.998,159.233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C344.039,158.378,344.422,158.761,344.422,159.233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C350.464,158.378,350.847,158.761,350.847,159.233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C356.888,158.378,357.271,158.761,357.271,159.233z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.696,159.233c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C363.313,158.378,363.696,158.761,363.696,159.233z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331.573,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C331.19,163.51,331.573,163.893,331.573,164.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C337.615,163.51,337.998,163.893,337.998,164.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C344.039,163.51,344.422,163.893,344.422,164.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C350.464,163.51,350.847,163.893,350.847,164.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C356.888,163.51,357.271,163.893,357.271,164.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.696,164.366c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C363.313,163.51,363.696,163.893,363.696,164.366z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 330.718,
    cy: 169.498,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.998,169.498c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C337.615,168.643,337.998,169.026,337.998,169.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.422,169.498c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C344.039,168.643,344.422,169.026,344.422,169.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.991,
    cy: 169.498,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.271,169.498c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C356.888,168.643,357.271,169.026,357.271,169.498z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.84,
    cy: 169.498,
    r: 0.855
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097494184234427817960000007998634979800497587_)"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.473,0.383-0.855,0.855-0.855 C332.827,222.446,333.21,222.829,333.21,223.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.634,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C339.251,222.446,339.634,222.829,339.634,223.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C345.676,222.446,346.059,222.829,346.059,223.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.483,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C352.1,222.446,352.483,222.829,352.483,223.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C358.525,222.446,358.908,222.829,358.908,223.301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,223.301c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C364.949,222.446,365.332,222.829,365.332,223.301z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C332.827,227.579,333.21,227.962,333.21,228.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.634,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C339.251,227.579,339.634,227.962,339.634,228.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C345.676,227.579,346.059,227.962,346.059,228.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.483,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C352.1,227.579,352.483,227.962,352.483,228.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C358.525,227.579,358.908,227.962,358.908,228.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,228.434c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C364.949,227.579,365.332,227.962,365.332,228.434z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,233.566c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C332.827,232.711,333.21,233.094,333.21,233.566z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.779,
    cy: 233.566,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,233.566c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C345.676,232.711,346.059,233.094,346.059,233.566z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.628,
    cy: 233.566,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,233.566c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C358.525,232.711,358.908,233.094,358.908,233.566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,233.566c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C364.949,232.711,365.332,233.094,365.332,233.566z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,238.699c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.473,0.383-0.855,0.855-0.855 C332.827,237.844,333.21,238.227,333.21,238.699z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.779,
    cy: 238.699,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,238.699c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C345.676,237.844,346.059,238.227,346.059,238.699z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.628,
    cy: 238.699,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,238.699c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C358.525,237.844,358.908,238.227,358.908,238.699z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,238.699c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.473,0.383-0.855,0.855-0.855C364.949,237.844,365.332,238.227,365.332,238.699z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C332.827,242.976,333.21,243.359,333.21,243.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.634,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C339.251,242.976,339.634,243.359,339.634,243.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C345.676,242.976,346.059,243.359,346.059,243.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.483,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C352.1,242.976,352.483,243.359,352.483,243.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C358.525,242.976,358.908,243.359,358.908,243.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,243.832c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C364.949,242.976,365.332,243.359,365.332,243.832z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855c0-0.472,0.383-0.855,0.855-0.855 C332.827,248.109,333.21,248.492,333.21,248.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.634,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C339.251,248.109,339.634,248.492,339.634,248.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C345.676,248.109,346.059,248.492,346.059,248.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.483,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C352.1,248.109,352.483,248.492,352.483,248.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C358.525,248.109,358.908,248.492,358.908,248.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,248.964c0,0.473-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855 c0-0.472,0.383-0.855,0.855-0.855C364.949,248.109,365.332,248.492,365.332,248.964z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.21,254.097c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C332.827,253.241,333.21,253.624,333.21,254.097z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.779,
    cy: 254.097,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.059,254.097c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C345.676,253.241,346.059,253.624,346.059,254.097z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.628,
    cy: 254.097,
    r: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.908,254.097c0,0.472-0.383,0.855-0.855,0.855c-0.472,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C358.525,253.241,358.908,253.624,358.908,254.097z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.332,254.097c0,0.472-0.383,0.855-0.855,0.855c-0.473,0-0.855-0.383-0.855-0.855s0.383-0.855,0.855-0.855 C364.949,253.241,365.332,253.624,365.332,254.097z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_346_",
    style: {
      fill: "#1D262D"
    },
    d: "M260.104,465.465c-0.432,0.443-0.803,0.931-1.108,1.453l-0.465-0.241 c-0.067-0.298-0.349-0.503-0.659-0.466c-0.331,0.039-0.568,0.339-0.529,0.67c0.039,0.331,0.339,0.568,0.67,0.529 c0.066-0.008,0.127-0.026,0.184-0.052l0.451,0.234c-0.251,0.554-0.433,1.139-0.539,1.744l0.747,0.132 c0.23-1.306,0.85-2.507,1.792-3.473L260.104,465.465z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_345_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.592,463.163c-0.171,0-0.341,0.006-0.51,0.017l-0.074-0.626 c0.188-0.149,0.296-0.389,0.266-0.645c-0.046-0.393-0.402-0.674-0.795-0.628c-0.393,0.046-0.674,0.402-0.628,0.795 c0.03,0.254,0.189,0.461,0.404,0.564l0.074,0.624c-0.714,0.116-1.403,0.332-2.06,0.646l0.327,0.684 c0.934-0.447,1.942-0.673,2.995-0.673c0.496,0,0.993,0.053,1.475,0.158l0.161-0.741 C266.692,463.222,266.142,463.163,265.592,463.163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_344_",
    style: {
      fill: "#1D262D"
    },
    d: "M272.194,465.711c0.331-0.04,0.566-0.341,0.526-0.672 c-0.04-0.331-0.341-0.566-0.672-0.526c-0.309,0.038-0.535,0.304-0.53,0.609l-0.416,0.363c-0.418-0.43-0.889-0.813-1.408-1.139 l-0.404,0.641c1.134,0.715,2.021,1.726,2.563,2.925l0.69-0.313c-0.251-0.554-0.567-1.072-0.942-1.545l0.402-0.351 C272.065,465.716,272.129,465.719,272.194,465.711z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_343_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.044,473.372c-0.386,0.023-0.775,0.035-1.157,0.035 c-0.88,0-1.733-0.061-2.478-0.179c-0.39-0.062-0.846-0.155-1.27-0.292c1.046,1.861,3.069,3.125,5.388,3.125 c2.855,0,5.262-1.916,5.95-4.504c-0.682,0.449-1.505,0.825-2.459,1.123C267.839,473.047,266.463,473.286,265.044,473.372z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    style: {
      fill: "#1D262D"
    },
    d: "M265.592,464.68c-3.352,0-6.08,2.666-6.08,5.943 c0,0.426,0.046,0.849,0.137,1.261c0.673,0.483,2.706,0.89,5.348,0.731c2.879-0.173,5.297-0.957,6.672-2.159 c-0.006-0.195-0.021-0.39-0.045-0.582C271.244,466.913,268.65,464.68,265.592,464.68z M263.432,471.194 c-1.02,0-1.85-0.83-1.85-1.85c0-1.02,0.83-1.85,1.85-1.85c1.02,0,1.85,0.83,1.85,1.85 C265.282,470.365,264.452,471.194,263.432,471.194z M268.17,470.286c-0.75,0-1.36-0.61-1.36-1.36s0.61-1.361,1.36-1.361 c0.75,0,1.361,0.61,1.361,1.361S268.92,470.286,268.17,470.286z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_336_",
    style: {
      fill: "#1D262D"
    },
    d: "M281.595,466.547c-0.295-0.116-0.805-0.309-1.382-0.237 c-0.551,0.069-0.844,0.341-0.844,1.007v0.866h2.228v1.717h-2.228v5.455h-1.932v-5.455h-1.34v-1.717h1.34v-0.888 c0-1.68,0.896-2.783,2.568-2.783c0.643,0,1.157,0.122,1.59,0.308L281.595,466.547z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    style: {
      fill: "#1D262D"
    },
    d: "M286.298,469.879c-0.177-0.03-0.358-0.046-0.526-0.046 c-0.896,0-1.51,0.548-1.51,1.614v3.908h-1.932v-7.172h1.873v0.785c0.451-0.673,1.14-0.977,2.021-0.977 c0.414,0,0.848,0.128,1.094,0.337L286.298,469.879z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_331_",
    style: {
      fill: "#1D262D"
    },
    d: "M293.965,471.757c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.933,1.488,1.843,1.488c0.622,0,1.295-0.252,1.813-0.688l1.133,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C292.544,467.99,293.958,469.522,293.965,471.757z  M288.851,471.091h3.175c-0.177-0.918-0.733-1.436-1.562-1.436C289.554,469.655,289.021,470.203,288.851,471.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    style: {
      fill: "#1D262D"
    },
    d: "M301.618,471.757c0,0.222-0.015,0.489-0.037,0.651h-5.085 c0.207,1.036,0.932,1.488,1.843,1.488c0.622,0,1.295-0.252,1.814-0.688l1.132,1.243c-0.814,0.748-1.85,1.088-3.057,1.088 c-2.198,0-3.723-1.495-3.723-3.753c0-2.258,1.48-3.797,3.627-3.797C300.197,467.99,301.611,469.522,301.618,471.757z  M296.504,471.091h3.175c-0.178-0.918-0.733-1.436-1.562-1.436C297.207,469.655,296.674,470.203,296.504,471.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    style: {
      fill: "#1D262D"
    },
    d: "M309.964,471.764c0,2.154-1.495,3.775-3.471,3.775 c-0.962,0-1.643-0.378-2.109-0.933v3.708h-1.924v-10.133h1.887v0.792c0.466-0.585,1.155-0.984,2.139-0.984 C308.469,467.99,309.964,469.61,309.964,471.764z M304.287,471.764c0,1.132,0.747,1.976,1.843,1.976 c1.14,0,1.85-0.881,1.85-1.976c0-1.095-0.71-1.976-1.85-1.976C305.035,469.788,304.287,470.632,304.287,471.764z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_322_",
    style: {
      fill: "#1D262D"
    },
    d: "M313.068,465.836c0,0.696-0.54,1.229-1.236,1.229 c-0.696,0-1.229-0.533-1.229-1.229c0-0.696,0.533-1.243,1.229-1.243C312.527,464.592,313.068,465.14,313.068,465.836z  M312.809,475.354h-1.932v-7.172h1.932V475.354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_320_",
    style: {
      fill: "#1D262D"
    },
    d: "M316.032,470.736l2.701-2.554h2.368l-3.479,3.375l3.501,3.797h-2.376 l-2.716-2.901v2.901H314.1v-10.658h1.932V470.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M184.412,475.289v-1.055c-0.527,0.718-1.391,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.816,0.469,2.388,1.245v-3.765h1.099v9.77H184.412z M184.412,473.37v-3.208 c-0.395-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.85,2.724,2.27,2.724 C183.168,474.483,184.017,473.986,184.412,473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M186.932,471.744c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.805,0,1.626-0.322,2.182-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C188.44,475.465,186.932,473.956,186.932,471.744z M190.403,468.947c-1.509,0-2.256,1.274-2.314,2.358h4.643 C192.718,470.25,192.015,468.947,190.403,468.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M194.607,474.351l0.571-0.791c0.469,0.542,1.362,1.011,2.329,1.011c1.084,0,1.67-0.513,1.67-1.216 c0-1.714-4.38-0.659-4.38-3.281c0-1.098,0.952-2.036,2.636-2.036c1.201,0,2.051,0.454,2.622,1.026l-0.513,0.762 c-0.424-0.513-1.201-0.894-2.109-0.894c-0.967,0-1.567,0.483-1.567,1.113c0,1.552,4.38,0.527,4.38,3.281 c0,1.187-0.952,2.138-2.783,2.138C196.306,475.465,195.325,475.113,194.607,474.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M201.477,466.471c0-0.41,0.337-0.747,0.732-0.747c0.41,0,0.747,0.337,0.747,0.747 c0,0.41-0.337,0.732-0.747,0.732C201.814,467.203,201.477,466.881,201.477,466.471z M201.667,475.289v-7.075h1.099v7.075H201.667 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M204.582,477.105l0.556-0.82c0.586,0.703,1.289,0.967,2.3,0.967c1.172,0,2.27-0.571,2.27-2.124 v-1.011c-0.513,0.718-1.377,1.26-2.373,1.26c-1.845,0-3.149-1.377-3.149-3.662c0-2.27,1.289-3.677,3.149-3.677 c0.952,0,1.802,0.469,2.373,1.245v-1.069h1.098v6.87c0,2.344-1.641,3.076-3.369,3.076 C206.237,478.16,205.417,477.926,204.582,477.105z M209.709,473.253v-3.091c-0.381-0.615-1.23-1.143-2.109-1.143 c-1.421,0-2.27,1.128-2.27,2.695c0,1.553,0.849,2.695,2.27,2.695C208.478,474.41,209.328,473.868,209.709,473.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M217.413,475.289v-4.629c0-1.245-0.63-1.641-1.582-1.641c-0.865,0-1.685,0.527-2.095,1.099v5.17 h-1.099v-7.075h1.099v1.025c0.498-0.586,1.465-1.201,2.519-1.201c1.48,0,2.256,0.747,2.256,2.285v4.966H217.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M219.932,471.744c0-2.051,1.465-3.706,3.486-3.706c2.139,0,3.398,1.67,3.398,3.794v0.279h-5.727 c0.088,1.333,1.025,2.446,2.549,2.446c0.806,0,1.626-0.322,2.183-0.894l0.527,0.718c-0.703,0.703-1.655,1.084-2.812,1.084 C221.441,475.465,219.932,473.956,219.932,471.744z M223.404,468.947c-1.509,0-2.256,1.274-2.314,2.358h4.643 C225.718,470.25,225.015,468.947,223.404,468.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M233.35,475.289v-1.055c-0.527,0.718-1.392,1.23-2.388,1.23c-1.846,0-3.149-1.406-3.149-3.706 c0-2.256,1.289-3.721,3.149-3.721c0.952,0,1.817,0.469,2.388,1.245v-3.765h1.098v9.77H233.35z M233.35,473.37v-3.208 c-0.396-0.615-1.245-1.143-2.124-1.143c-1.421,0-2.27,1.172-2.27,2.739c0,1.567,0.849,2.724,2.27,2.724 C232.105,474.483,232.954,473.986,233.35,473.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M239.692,475.289v-9.77h1.098v3.765c0.572-0.776,1.421-1.245,2.388-1.245 c1.845,0,3.149,1.465,3.149,3.721c0,2.299-1.304,3.706-3.149,3.706c-0.996,0-1.86-0.513-2.388-1.23v1.055H239.692z  M242.9,474.483c1.436,0,2.285-1.157,2.285-2.724c0-1.568-0.85-2.739-2.285-2.739c-0.864,0-1.728,0.527-2.109,1.143v3.208 C241.171,473.986,242.036,474.483,242.9,474.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D262D"
    },
    d: "M247.528,477.061c0.161,0.073,0.425,0.117,0.601,0.117c0.483,0,0.805-0.161,1.055-0.747 l0.469-1.069l-2.959-7.148h1.187l2.358,5.8l2.344-5.8h1.201l-3.545,8.51c-0.425,1.025-1.143,1.421-2.08,1.435 c-0.234,0-0.601-0.044-0.805-0.103L247.528,477.061z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaim);
export default __webpack_public_path__ + "static/media/defaim.e4ee03e8f30319a23b14c651d1b266c7.svg";
export { ForwardRef as ReactComponent };